// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T23:01:44.794Z
// Property: The Clairborne Apartment Homes (ID: 6767906449167591)
// Collections: 29 amenities, 8 floorplans (live), 46 photos, 74 POIs, 12 reviews, 1 virtual tours, 6 office hours, 17 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162465",
  "multihub_property_id": "6767906449167591",
  "property_external_id": "1124082",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/the-clairborne-apartment-homes-grand-prairie-tx/wylvzmk/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Clairborne+Apartment+Homes/@32.7910979,-97.0598015,831m/data=!3m2!1e3!4b1!4m6!3m5!1s0x864e80d2bb49ba41:0x9631a6946f14b285!8m2!3d32.7910979!4d-97.0598015!16s%2Fg%2F1tdlvpfz?entry=ttu&g_ep=EgoyMDI2MDkxNi4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "1124082 p1099034",
  "property_status": null,
  "property_slug": "the-clairborne-apartment-homes",
  "property_name": "The Clairborne Apartment Homes",
  "property_website_url": "https://www.clairborneapts.com/",
  "property_domain": "https://www.clairborneapts.com/",
  "property_address": "2355 N Hwy 360",
  "property_full_address": "2355 N Hwy 360, Grand Prairie, TX 75050",
  "property_address_1": "2355 N Hwy 360",
  "property_address_2": null,
  "property_address_city": "Grand Prairie",
  "property_address_state": "TX",
  "property_address_zip_full": null,
  "property_address_zip": "75050",
  "property_address_country": "US",
  "property_address_county": "Tarrant County",
  "property_neighborhood_address": "North Arlington",
  "property_address_latitude": "32.7903641",
  "property_address_longitude": "-97.0595914",
  "property_email": "rentcafe.cb@pricekc.com",
  "property_phone": "(817) 760-2136",
  "property_call_tracking_phone": "817-760-2136",
  "property_company_name": "Price Brothers",
  "property_company_url": "https://www.pricebrotherskc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Connected Grand Prairie living, easy everyday comfort.</strong> The Clairborne pairs gated community amenities with spacious one-, two-, and three-bedroom homes near Highway 360—explore the <a href=\"/amenities\">amenities</a> and <a href=\"/schedule-a-tour\">schedule a tour</a> to see it in person.</p>",
  "property_long_description": "<p>Welcome to The Clairborne Apartment Homes, a scenic, park-like community offering modern one, two, and three-bedroom apartments off Highway 360 in Grand Prairie, TX. Enjoy spacious layouts with nine-foot ceilings, crown molding, and a private patio or balcony, with select homes featuring a solarium, a travertine fireplace, and built-in wine racks.</p><p>Unwind at our resort-style swimming pool, challenge a neighbor to billiards in the clubhouse, or get a workout in at our 24-hour fitness center. Browse our full list of community and apartment amenities to see everything included in your new home.</p><p>Located just minutes from Lake Viridian and River Legacy Park, The Clairborne Apartment Homes also keeps the dining, shopping, and entertainment of Fort Worth and Dallas within easy reach. View our photo gallery, explore the Grand Prairie neighborhood, or contact us to schedule your tour today.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
  "property_featured_image_media": {
    "alt_text": "Aerial view of an apartment complex courtyard with a large swimming pool, lounge chairs, umbrellas, and a gazebo.",
    "public_id": "019fc926-2ff8-7658-be86-0fcbc17a81ed",
    "storage_key": "property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
    "width": 3072,
    "height": 2047
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "274",
  "property_year_built": "1997",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.7956204379562",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $175-375",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Restrictions: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.",
  "property_pet_policy_description": "The non-refundable fee is $300 for 1 pet, and $500 for 2 pets.",
  "property_petpolicy_info": "https://www.pricebrotherskc.com/petroyaltyclub/",
  "property_online_leasing_url": "https://clairborneapts.securecafeapplicant.com/onlineleasing/content3/access/clairborne/floorplans",
  "property_resident_portal_url": "https://clairborneapts.securecafe.com/residentservices/clairborne/userlogin.aspx",
  "property_apply_now_url": "https://clairborneapts.securecafeapplicant.com/onlineleasing/content3/access/clairborne/login",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a18e9b-0ffa-77d3-bcf4-94f9a61ff7f3.webp",
  "property_primary_logo_media": {
    "alt_text": "The Clairborne Apartment Homes logo",
    "public_id": "01a18e9b-0ffa-77d3-bcf4-94f9a61ff7f3",
    "storage_key": "property/6767906449167591/01a18e9b-0ffa-77d3-bcf4-94f9a61ff7f3.webp",
    "width": 3072,
    "height": 901
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a18e9b-102c-76af-b09b-13a4606fbcd6.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Clairborne Apartment Homes logo",
    "public_id": "01a18e9b-102c-76af-b09b-13a4606fbcd6",
    "storage_key": "property/6767906449167591/01a18e9b-102c-76af-b09b-13a4606fbcd6.webp",
    "width": 3072,
    "height": 901
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a18e9b-0fbd-757c-be55-547e2e144ccc.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Clairborne Apartment Homes logo",
    "public_id": "01a18e9b-0fbd-757c-be55-547e2e144ccc",
    "storage_key": "property/6767906449167591/01a18e9b-0fbd-757c-be55-547e2e144ccc.webp",
    "width": 3072,
    "height": 901
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a0d9b7-62d2-753a-a137-bd690ff6733b.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff68a-de80-741a-9687-3e84c8c517e3.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#1F2A44",
  "property_secondary_color": "#FF9E1B",
  "property_font_color": null,
  "property_color_4": "#FBF5F3",
  "property_color_3": "#009A44",
  "property_color_5": "#7B0828",
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "650 - 1314",
  "property_sqft_min": "650",
  "property_sqft_max": "1314",
  "property_price_range": "1101 - 7014",
  "property_price_min": "1101",
  "property_price_max": "7014",
  "property_available_units": 18,
  "property_facebook_url": "https://www.facebook.com/ClairborneApts",
  "property_instagram_url": "https://www.instagram.com/clairborneapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJQbpJu9KAToYRhbIUb5SmMZY",
  "property_youtube_url": "https://www.youtube.com/user/Pricebrothersmgt",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Clairborne Apartment Homes",
  "property_home_romance_title": "Embrace the Charm of Your New Apartment Community",
  "property_home_amenities_blurb": "<p><strong>Everyday ease, finished with standout details.</strong> At The Clairborne Apartment Homes, amenities stretch from a year-round pool and jacuzzi to a fitness center, business center, clubhouse billiards, grilling areas, and gated courtyards. Inside, nine-foot ceilings, crown molding, stainless steel appliances, spacious closets, washer/dryer connections, and private patios or balconies add polish, while select layouts feature solariums, garden tubs, built-ins, wine racks, or travertine fireplaces.</p>",
  "property_home_floorplans_blurb": "<p><strong>Layouts with room to stand out.</strong> Explore one-, two-, and three-bedroom apartment homes in Grand Prairie with modern kitchens, stainless steel appliances, washer/dryer connections, roomy closets, and private patios or balconies. Select layouts add nine-foot ceilings, crown molding, fireplaces, built-ins, wine racks, garden tubs, breakfast nooks, or sunroom-style solariums—giving each floor plan its own polished personality.</p>",
  "property_home_gallery_blurb": "<p>Take a closer look at our spacious one, two, and three-bedroom apartments, from modern kitchens to private patios and balconies. Browse our <a href=\"/gallery\">photo gallery</a> for a preview of the community, amenities, and apartment interiors.</p>",
  "property_home_neighborhood_blurb": "<p>Positioned right off Highway 360, The Clairborne Apartment Homes offers quick access to the Grand Prairie Premium Outlets, Lincoln Square, and a wide range of restaurants. Commuters will appreciate the proximity to Fort Worth and Dallas, while nature lovers can spend an afternoon at Lake Viridian or River Legacy Park. Visit our <a href=\"/neighborhood\">Neighborhood page</a> for more on what’s nearby.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents keep noticing the details.</strong> Reviews for The Clairborne Apartment Homes often mention clean, quiet surroundings, well-kept grounds, an inviting pool area, and comfortable apartment homes. Many also call out the office team and maintenance service for being courteous, efficient, and responsive. It’s the kind of feedback that points to a community cared for day after day—see what residents are saying.</p>",
  "property_neighborhood_blurb": "<p>The Clairborne Apartment Homes is located at 2355 N. Highway 360, Grand Prairie, TX 75050, with easy commutes across Dallas-Fort Worth. Nearby employers include Lockheed Martin, Verizon, and Texas Health Arlington Memorial Hospital, and the University of Texas at Arlington and Grand Prairie ISD campuses are minutes away.</p><p>For fun, Bolder Adventure Park, Epic Central, Six Flags Over Texas, and AT&amp;T Stadium are a short drive away, along with shopping at Grand Prairie Premium Outlets and Lincoln Square. Lake Viridian and River Legacy Park offer green space close to home.</p><p>Looking for a place to eat? Our team recommends Holy Tacos, Chicken Express for a quick bite, and Nehemiah Coffee Company for your morning coffee.</p><p>Explore our <a href=\"/floor-plans\">floor plans</a> and <a href=\"/amenities\">amenities</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>The Clairborne Apartment Homes brings together resort-style leisure spaces and thoughtful in-home features. Take a dip in our shimmering swimming pool, get in a workout at our 24-hour fitness center, or catch up with neighbors over a game of billiards in the clubhouse. Additional community amenities include a business center, gated access, an on-site courtesy officer, and covered parking or garage options.</p><p>Inside your <a href=\"/floor-plans\">one, two, or three-bedroom apartment</a>, enjoy nine-foot ceilings, crown molding, a garden tub, and spacious closets. Select homes also feature a private solarium, a travertine fireplace with mantle, built-in wine racks, or a breakfast nook, adding an extra layer of comfort to your day-to-day life.</p><p>Ready to see these amenities in person? <a href=\"/schedule-a-tour\">Schedule a tour</a> of The Clairborne Apartment Homes today.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make The Clairborne home?</strong> Start your online application for a one-, two-, or three-bedroom apartment with the space, finishes, and everyday conveniences that fit your routine—set within a gated Grand Prairie community near Highway 360.</p>",
  "property_contactus_blurb": "<p>Looking for more information about The Clairborne Apartment Homes? Our team can answer questions about <a href=\"/floor-plans\">available floor plans</a>, pricing, <a href=\"/amenities\">community and apartment amenities</a>, or scheduling a tour.</p><p>Call us, visit the leasing office at 2355 N Highway 360, Grand Prairie, TX 75050, or complete the contact form above. We look forward to hearing from you.</p>",
  "property_faqs_blurb": "<p>Find answers to common questions about applications, deposits, lease terms, pets, utilities, renters insurance, and maintenance requests at The Clairborne Apartment Homes. You can also review our <a href=\"/floor-plans\">floor plans</a> and <a href=\"/amenities\">amenities</a> for more information.</p><p>If you don’t see the answer you need, <a href=\"/contact-us\">contact us</a>. We’re happy to help.</p>",
  "property_floorplans_blurb": "<p>Choose from eight floor plans at The Clairborne Apartment Homes, with one-bedroom apartments starting at 650 square feet, two-bedroom homes ranging from 905 to 1,314 square feet, and a spacious three-bedroom layout at 1,211 square feet. Every home includes nine-foot ceilings, a garden tub, built-in wine racks, and generous closet space, and select apartments add a private solarium, a travertine fireplace with mantle, or a built-in breakfast nook.</p><p>Looking for extra natural light? Our Magnolia Solarium and Tara Solarium floor plans include a dedicated solarium space, a sought-after feature that’s harder to find at other Grand Prairie communities. Compare pricing and current availability, then choose your apartment using our interactive property map or review our full list of <a href=\"/amenities\">community and apartment amenities</a>. Pets are welcome.</p><p>Ready to see a floor plan in person? <a href=\"/contact-us\">Contact us</a> to schedule a tour of The Clairborne Apartment Homes.</p>",
  "property_gallery_blurb": "<p>Browse the photo gallery for a closer look at The Clairborne Apartment Homes in Grand Prairie, TX. View spacious one-, two-, and three-bedroom apartment interiors, along with community spaces like the swimming pool, clubhouse, billiards lounge, and 24-hour fitness center.</p><p>Look for details throughout the gallery, including nine-foot ceilings, crown molding, built-in wine racks, and select solariums and travertine fireplaces. After browsing, compare our <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see The Clairborne Apartment Homes in person.</p>",
  "property_interactivemap_blurb": "<p>Use our interactive property map to explore available apartments at The Clairborne Apartment Homes by building, floor plan, and location within the community. Select a unit to view pricing, square footage, and availability, then review our full list of <a href=\"/floor-plans\">floor plans</a> and <a href=\"/amenities\">amenities</a> for more details.</p><p>Ready to find your new home? <a href=\"/contact-us\">Contact us</a> to schedule a tour.</p>",
  "property_pets_blurb": "<p>The Clairborne Apartment Homes welcomes cats and dogs, with a maximum of two pets per apartment.</p><ul><li><strong>Monthly pet rent:</strong> $25 per pet</li><li><strong>Non-refundable pet fee:</strong> $300 for one pet or $500 for two pets</li></ul><p>Breed Restrictions: Restricted breeds include Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and mixes containing any of these breeds. Management may restrict additional breeds. Exotic, feral, wild, or inherently dangerous animals are not permitted.</p><p>As part of the <a href=\"https://www.pricebrotherskc.com/petroyaltyclub/\" target=\"_blank\">Price Brothers Pet Royalty Club</a>, every pet-owning resident gains access to exclusive discounts at local pet-related businesses with payment of the one-time pet fee. Learn more on the <a href=\"https://www.pricebrotherskc.com/petroyaltyclub/\" target=\"_blank\">Price Brothers Management website</a>.</p>",
  "property_referafriend_blurb": "<p><strong>Love life at The Clairborne?</strong> Share the connected Grand Prairie location, gated community spaces, and comfortable one-, two-, and three-bedroom homes with someone you know. Use the referral form to invite a friend to make The Clairborne Apartment Homes their next address.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at The Clairborne.</strong> Manage your account, pay rent, and submit maintenance requests in one convenient place. From package service to on-site maintenance and planned resident events, everyday living is designed to stay connected, simple, and close to what you need.</p>",
  "property_reviews_blurb": "<p><strong>Resident feedback says a lot.</strong> As you read reviews for The Clairborne Apartment Homes, you’ll see recurring praise for a community that feels clean, quiet, and well cared for, with attentive office team members and maintenance service residents describe as courteous, efficient, and responsive.</p><p>Reviewers often highlight the well-kept grounds, inviting pool area, pet-friendly conveniences, and comfortable apartment homes, along with a location that keeps daily routines simple. One resident sums it up as a “clean, quiet, and well kept apartment complex”—a theme echoed throughout the experiences shared here.</p>",
  "property_created_at": "1785786088045",
  "property_scheduletour_blurb": "<p>Ready to see The Clairborne Apartment Homes in person? Schedule a tour of our Grand Prairie, TX apartments and explore our available one-, two-, and three-bedroom floor plans. During your visit, you can take a closer look at our apartment interiors, community spaces, and features while learning more about available homes. Choose a convenient date and time to plan your visit today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — your inquiry has been received.</strong><br>The Clairborne leasing team will follow up soon to help with your next steps. In the meantime, picture connected Grand Prairie living just off Highway 360, with gated community spaces, a year-round pool and jacuzzi, and one-, two-, and three-bedroom homes designed for everyday comfort.</p>",
  "property_virtualtours_blurb": "<p>Take a closer look at select floor plans at The Clairborne Apartment Homes with virtual tours that show how each apartment is arranged. Move through the layouts online to view living areas, kitchens, and bedrooms at your own pace.</p><p>Visit our complete <a href=\"/floor-plans\">floor plan collection</a> to review square footage, pricing, and current availability, or <a href=\"/schedule-a-tour\">schedule a guided tour</a> to explore The Clairborne Apartment Homes in person.</p>",
  "property_copyright": "2026 All Rights Reserved. The Clairborne Apartment Homes",
  "property_seo_title_home": "Apartments Off 360 in Grand Prairie, TX",
  "property_seo_description_home": "Discover The Clairborne Apartment Homes, offering 1, 2 & 3-bedroom apartments off Highway 360 in Grand Prairie, TX with resort-style amenities. Tour today!",
  "property_seo_title_floorplans": "1, 2 & 3-Bed Apartments in Grand Prairie, TX",
  "property_seo_description_floorplans": "Explore 1, 2 & 3-bedroom floor plans at The Clairborne Apartment Homes in Grand Prairie, TX, including select apartments with private solariums.",
  "property_seo_title_amenities": "Luxury Apartment Amenities in Grand Prairie, TX",
  "property_seo_description_amenities": "See the amenities at The Clairborne Apartment Homes in Grand Prairie, TX, from a swimming pool and fitness center to select solariums. Tour today!",
  "property_seo_title_gallery": "The Clairborne Apartment Homes | Photo Gallery",
  "property_seo_description_gallery": "Browse photos of The Clairborne Apartment Homes in Grand Prairie, TX, including apartment interiors, the swimming pool, clubhouse, and fitness center.",
  "property_seo_title_virtualtours": "Apartment Virtual Tours in Grand Prairie, TX",
  "property_seo_description_virtualtours": "Take a virtual tour of select floor plans at The Clairborne Apartment Homes in Grand Prairie, TX, before scheduling an in-person visit.",
  "property_seo_title_interactivemap": "Interactive Property Map | The Clairborne",
  "property_seo_description_interactivemap": "Use the interactive property map at The Clairborne Apartment Homes to explore available apartments and floor plans in Grand Prairie, TX.",
  "property_seo_title_neighborhood": "Apartments Near Bolder Adventure Park, TX",
  "property_seo_description_neighborhood": "The Clairborne Apartment Homes sits off Highway 360 in Grand Prairie, TX, near Bolder Adventure Park, Lake Viridian, and Grand Prairie Premium Outlets.",
  "property_seo_title_contact": "Contact The Clairborne Apartment Homes | TX",
  "property_seo_description_contact": "Contact The Clairborne Apartment Homes in Grand Prairie, TX to ask about floor plans, pricing, availability, or scheduling a tour.",
  "property_seo_title_faqs": "FAQs | The Clairborne Apartment Homes",
  "property_seo_description_faqs": "Find answers about applications, pet policies, utilities, and maintenance at The Clairborne Apartment Homes in Grand Prairie, TX.",
  "property_seo_title_reviews": "Reviews | The Clairborne Apartment Homes",
  "property_seo_description_reviews": "Read reviews from residents of The Clairborne Apartment Homes in Grand Prairie, TX, and see why renters choose our community.",
  "property_seo_title_applynow": "Apply Now | Apartments in Grand Prairie, TX",
  "property_seo_description_applynow": "Experience luxury living at The Clairborne in Grand Prairie, TX! Choose from spacious one to three-bedroom homes, enjoy top amenities, and apply online today!",
  "property_seo_title_residentaccess": "Resident Access | The Clairborne Apartment Homes",
  "property_seo_description_residentaccess": "Experience seamless living at The Clairborne in Grand Prairie, TX! Access your resident portal for rent payments, maintenance requests, and more.",
  "property_seo_title_referafriend": "Refer A Friend | The Clairborne Apartment Homes",
  "property_seo_description_referafriend": "Refer a friend to The Clairborne Apartment Homes in Grand Prairie, TX! Great friends make great neighbors—share the comfort and community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | The Clairborne Apartment Homes",
  "property_seo_description_scheduletour": "Unveil your perfect home at The Clairborne in Grand Prairie! Experience luxury living, fabulous amenities, and vibrant community life. Schedule a tour today!",
  "property_seo_title_privacy": "Privacy Policy | The Clairborne Apartment Homes",
  "property_seo_description_privacy": "At The Clairborne Apartment Homes in Grand Prairie, TX, your privacy matters. Dive into our policy to see how we protect your personal information.",
  "property_seo_title_accessibility": "Website Accessibility | The Clairborne Apartment Homes",
  "property_seo_description_accessibility": "At The Clairborne Apartment Homes in Grand Prairie, TX, we champion digital accessibility, ensuring everyone can enjoy an inclusive living experience.",
  "property_seo_title_sitemap": "Sitemap | The Clairborne Apartment Homes",
  "property_seo_description_sitemap": "Uncover a world of comfort at The Clairborne Apartment Homes in Grand Prairie, TX. View our sitemap to navigate your way to your ideal living space!",
  "property_seo_title_thankyou": "Thank You | The Clairborne Apartment Homes",
  "property_seo_description_thankyou": "Thanks for connecting with The Clairborne in Grand Prairie, TX! We’ll be in touch soon to help you find your perfect apartment home. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Grand Prairie, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793742955872",
  "amenities": [
    {
      "id": "ec_0748e0a4b2c8382c5afcb216",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "yardi",
      "external_id": "87751995",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dc-7592-741b-9e63-87448b270ff8.webp",
      "amenity_image_media": {
        "alt_text": "Business center with computers and printer",
        "public_id": "01a0b5dc-7592-741b-9e63-87448b270ff8",
        "storage_key": "property/6767906449167591/01a0b5dc-7592-741b-9e63-87448b270ff8.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "Business Center at The Clairborne Apartment Homes, Grand Prairie, TX, 75050",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bc39e787818565db68b94004",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "yardi",
      "external_id": "87751996",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dc-69ea-719f-b0ec-9d08bf7e15d8.webp",
      "amenity_image_media": {
        "alt_text": "Community room with a pool table, seating area, and dining table.",
        "public_id": "01a0b5dc-69ea-719f-b0ec-9d08bf7e15d8",
        "storage_key": "property/6767906449167591/01a0b5dc-69ea-719f-b0ec-9d08bf7e15d8.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "Clubhouse at The Clairborne Apartment Homes, Grand Prairie",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_509c51f800e52b2a76760eee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "yardi",
      "external_id": "87751997",
      "title": "Gated Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_532188d04f7342f88cbddfe4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "yardi",
      "external_id": "87751999",
      "title": "High Speed Internet Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_25ee92253e50b62549b53221",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "yardi",
      "external_id": "87752001",
      "title": "Shimmering Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dc-6dc3-75bd-8ad2-60b7b81afe3f.webp",
      "amenity_image_media": {
        "alt_text": "Aerial view of a swimming pool and gazebo area at a multifamily property.",
        "public_id": "01a0b5dc-6dc3-75bd-8ad2-60b7b81afe3f",
        "storage_key": "property/6767906449167591/01a0b5dc-6dc3-75bd-8ad2-60b7b81afe3f.webp",
        "width": 3072,
        "height": 2047
      },
      "amenity_image_alt_text": "Shimmering Swimming Pool at The Clairborne Apartment Homes, Grand Prairie, 75050",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e3eceee62a536f9929c90f74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "yardi",
      "external_id": "87751998",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dc-6934-71ea-b4ed-b6366f697bc1.webp",
      "amenity_image_media": {
        "alt_text": "Gym with treadmills, ellipticals, weight machines, and mirrors.",
        "public_id": "01a0b5dc-6934-71ea-b4ed-b6366f697bc1",
        "storage_key": "property/6767906449167591/01a0b5dc-6934-71ea-b4ed-b6366f697bc1.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "Fitness Center at The Clairborne Apartment Homes, Grand Prairie, TX,Fitness Center at The Clairborne Apartment Homes, TX, 75050",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d2007b3a39523f90bb23f823",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "yardi",
      "external_id": "87752043",
      "title": "Covered Parking/ Garage Options",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5dc5422c2d5787d1df7a7926",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "yardi",
      "external_id": "87752002",
      "title": "Billiards",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dc-6ad9-77a3-913a-dfcec793f603.webp",
      "amenity_image_media": {
        "alt_text": "Billiard table and seating area in community lounge.",
        "public_id": "01a0b5dc-6ad9-77a3-913a-dfcec793f603",
        "storage_key": "property/6767906449167591/01a0b5dc-6ad9-77a3-913a-dfcec793f603.webp",
        "width": 3072,
        "height": 2049
      },
      "amenity_image_alt_text": "Billiards at The Clairborne Apartment Homes, Texas, 75050",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a9c5f98c65bcf1ae05100a46",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "yardi",
      "external_id": "87752003",
      "title": "Curbside Trash Pick Up",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ad0a2d23942b75ea58e9cb1e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "yardi",
      "external_id": "87752004",
      "title": "Jacuzzi",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f305f1e36670b7d7edb1e0a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "yardi",
      "external_id": "87752005",
      "title": "On Call Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_41e41a44ab8b05dc2f57b3b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "yardi",
      "external_id": "87752006",
      "title": "On Site Courtesy Officer",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5f86a48f530cb55e3459c75e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "yardi",
      "external_id": "122755407",
      "title": "Flexible Rent Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4d1a9bcbdf07f218a7769da0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "yardi",
      "external_id": "87752022",
      "title": "9ft Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f3687acc99fadd3f3e8505fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "yardi",
      "external_id": "87752018",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_caab384a4599270698e3ba19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "yardi",
      "external_id": "87752021",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a7131374150612bc1a6ada8d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "yardi",
      "external_id": "87752033",
      "title": "Private Balconies and Patios",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dc-a417-771f-abf2-104957203638.webp",
      "amenity_image_media": {
        "alt_text": "Balcony overlooking a parking lot and apartment buildings.",
        "public_id": "01a0b5dc-a417-771f-abf2-104957203638",
        "storage_key": "property/6767906449167591/01a0b5dc-a417-771f-abf2-104957203638.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "Private Balconies and Patios at The Clairborne Apartment Homes, Grand Prairie, TX",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b9f4a8aac8cd51380f3915e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "yardi",
      "external_id": "87752036",
      "title": "Travertine Fireplace with Mantle*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dc-9c10-7390-a354-def4a25bc2aa.webp",
      "amenity_image_media": {
        "alt_text": "Spacious living room with white sofa, fireplace, TV, bookshelves, and view into kitchen.",
        "public_id": "01a0b5dc-9c10-7390-a354-def4a25bc2aa",
        "storage_key": "property/6767906449167591/01a0b5dc-9c10-7390-a354-def4a25bc2aa.webp",
        "width": 3000,
        "height": 2002
      },
      "amenity_image_alt_text": "Travertine Fireplace with Mantle at The Clairborne Apartment Homes, Grand Prairie, 75050",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0ffc53bb92e4f867ac292359",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "yardi",
      "external_id": "87752042",
      "title": "Washer/Dryer Connections",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2fbe816d57b7eae6ae9a7bd7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "yardi",
      "external_id": "87752023",
      "title": "Breakfast Nook*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dc-8715-769d-bad9-e2668112e7ba.webp",
      "amenity_image_media": {
        "alt_text": "Living room with fireplace and shelving, connected to dining area and kitchen.",
        "public_id": "01a0b5dc-8715-769d-bad9-e2668112e7ba",
        "storage_key": "property/6767906449167591/01a0b5dc-8715-769d-bad9-e2668112e7ba.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "Breakfast Nook at The Clairborne Apartment Homes, Grand Prairie, TX, 75050",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bbbce5986b6189b6a8aaebbb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "yardi",
      "external_id": "87752024",
      "title": "Built-in Desk*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_522e7b58fc703a35cae76dea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "yardi",
      "external_id": "87752025",
      "title": "Built In Wine Racks",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_434d62f92f2ac15b1a728dd5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "yardi",
      "external_id": "87752026",
      "title": "Crown Molding",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_833c1149d6c374f5ff18ea66",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "yardi",
      "external_id": "87752034",
      "title": "Garden Tub",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f0c6e2920a8138a747e92f2e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "yardi",
      "external_id": "87752035",
      "title": "Pantry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8100afc8e72360141517835b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "yardi",
      "external_id": "87752038",
      "title": "Smoke Alarms and Sprinkler Protection",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dc7999cfbc04568920643c8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "yardi",
      "external_id": "87752039",
      "title": "Solarium*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_72d30a4140f8fda5244b213e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "yardi",
      "external_id": "87752040",
      "title": "Spacious Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dc-a657-7760-9064-5c4b2cc79f1f.webp",
      "amenity_image_media": {
        "alt_text": "Spacious walk-in closet with organized clothing on wire shelves.",
        "public_id": "01a0b5dc-a657-7760-9064-5c4b2cc79f1f",
        "storage_key": "property/6767906449167591/01a0b5dc-a657-7760-9064-5c4b2cc79f1f.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "Spacious Closets at The Clairborne Apartment Homes, TX, 75050",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a0884d92ea355126a6164b46",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "yardi",
      "external_id": "87760281",
      "title": "Built-In Bookshelves*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_38f14a71a2880e9a1ff1d92a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dc-5267-745a-8e01-c97c5e22552a.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex courtyard with a swimming pool and gazebo.",
        "public_id": "01a0b5dc-5267-745a-8e01-c97c5e22552a",
        "storage_key": "property/6767906449167591/01a0b5dc-5267-745a-8e01-c97c5e22552a.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Enjoy the resort-style living at our community, featuring a beautiful swimming pool, spa, and outdoor seating areas. Perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "Aerial view of apartment complex courtyard with a swimming pool and gazebo.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/04-2355 N Hwy 360 -6 copy.jpg"
    },
    {
      "id": "ec_475f53ece22da3f6e031ed6a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dc-ce07-73cc-8933-da9984b7306f.webp",
      "image_media": {
        "alt_text": "View of parking lot and apartment building from balcony.",
        "public_id": "01a0b5dc-ce07-73cc-8933-da9984b7306f",
        "storage_key": "property/6767906449167591/01a0b5dc-ce07-73cc-8933-da9984b7306f.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy convenient parking and a beautiful view from your private balcony, overlooking the community grounds and apartment buildings.",
      "link": "false",
      "alt_text": "View of parking lot and apartment building from balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/38-2355 N Hwy 360 -29.jpg"
    },
    {
      "id": "ec_792eda541f7f524711c52a24",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dc-cd8a-71dd-82ba-75ff2a41ce69.webp",
      "image_media": {
        "alt_text": "Spacious living room with a white couch, coffee table, and abstract art.",
        "public_id": "01a0b5dc-cd8a-71dd-82ba-75ff2a41ce69",
        "storage_key": "property/6767906449167591/01a0b5dc-cd8a-71dd-82ba-75ff2a41ce69.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed living room, featuring a plush white sofa, a modern coffee table, and striking abstract artwork. Perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "Spacious living room with a white couch, coffee table, and abstract art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/41-2355 N Hwy 360 -34_final.jpg"
    },
    {
      "id": "ec_d3d4bcdd123459fc99a0c6ef",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dc-b6db-71b9-aafa-e323cf3db2d6.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen with stainless steel appliances and granite countertops.",
        "public_id": "01a0b5dc-b6db-71b9-aafa-e323cf3db2d6",
        "storage_key": "property/6767906449167591/01a0b5dc-b6db-71b9-aafa-e323cf3db2d6.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Enjoy meals in the dining area or cook in the modern kitchen featuring stainless steel appliances and granite countertops.",
      "link": "false",
      "alt_text": "Dining area and kitchen with stainless steel appliances and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/35-2355 N Hwy 360 -25_final.jpg"
    },
    {
      "id": "ec_cdf7dacc1f019c3cc4725827",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dc-cdec-75ee-97ef-9b9e0fd9e975.webp",
      "image_media": {
        "alt_text": "Spacious living room with a fireplace, mounted TV, and large windows.",
        "public_id": "01a0b5dc-cdec-75ee-97ef-9b9e0fd9e975",
        "storage_key": "property/6767906449167591/01a0b5dc-cdec-75ee-97ef-9b9e0fd9e975.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Step into this inviting living room, featuring a cozy fireplace, a mounted television, and ample natural light from large windows. Perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "Spacious living room with a fireplace, mounted TV, and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/39-2355 N Hwy 360 -33_final.jpg"
    },
    {
      "id": "ec_23f3f138f7cc94879d91d6ed",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dc-b66e-71cf-bcb2-7e068d9c6525.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace, a large bookshelf, and a view into the kitchen.",
        "public_id": "01a0b5dc-b66e-71cf-bcb2-7e068d9c6525",
        "storage_key": "property/6767906449167591/01a0b5dc-b66e-71cf-bcb2-7e068d9c6525.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a modern fireplace, elegant built-in bookshelves, and an open-concept layout flowing into the kitchen.",
      "link": "false",
      "alt_text": "Living room with a fireplace, a large bookshelf, and a view into the kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/43-2355 N Hwy 360 -35_final.jpg"
    },
    {
      "id": "ec_034b22cb8a96697e98ae2d29",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dc-bf1e-75af-a39c-5b6443cac44d.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-sized bed, modern abstract art, and ceiling fan.",
        "public_id": "01a0b5dc-bf1e-75af-a39c-5b6443cac44d",
        "storage_key": "property/6767906449167591/01a0b5dc-bf1e-75af-a39c-5b6443cac44d.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-sized bed, a stylish abstract wall art, and a convenient ceiling fan for added comfort.",
      "link": "false",
      "alt_text": "Bedroom with a king-sized bed, modern abstract art, and ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/69-2355 N Hwy 360 -46_final.jpg"
    },
    {
      "id": "ec_848f4de99cfcd6eaf3dc520c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dc-d684-7359-a07f-66af64395e5d.webp",
      "image_media": {
        "alt_text": "Balcony with table and chairs overlooking parking lot and apartment buildings.",
        "public_id": "01a0b5dc-d684-7359-a07f-66af64395e5d",
        "storage_key": "property/6767906449167591/01a0b5dc-d684-7359-a07f-66af64395e5d.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening cocktail on your private balcony, with views of the surrounding community and parking areas.",
      "link": "false",
      "alt_text": "Balcony with table and chairs overlooking parking lot and apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/37-2355 N Hwy 360 -29_final.jpg"
    },
    {
      "id": "ec_1c5e5c1b301208658865f848",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dc-c806-7191-97b4-07bef8cb124c.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with manicured lawns and mature trees under a blue sky with clouds.",
        "public_id": "01a0b5dc-c806-7191-97b4-07bef8cb124c",
        "storage_key": "property/6767906449167591/01a0b5dc-c806-7191-97b4-07bef8cb124c.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Spacious grounds and beautiful landscaping surround these apartment homes, offering a serene and comfortable living environment.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with manicured lawns and mature trees under a blue sky with clouds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/60-2355 N Hwy 360 -32.jpg"
    },
    {
      "id": "ec_bc3e227ff4e3b93eda05336c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dc-d0dd-7559-b030-74eb9918fbc7.webp",
      "image_media": {
        "alt_text": "Aerial view of a sprawling multifamily apartment complex with multiple buildings, courtyards, parking, and a pool.",
        "public_id": "01a0b5dc-d0dd-7559-b030-74eb9918fbc7",
        "storage_key": "property/6767906449167591/01a0b5dc-d0dd-7559-b030-74eb9918fbc7.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "An aerial perspective showcases this extensive apartment community, featuring numerous residential buildings, lush landscaping, convenient parking, and a refreshing swimming pool.",
      "link": "false",
      "alt_text": "Aerial view of a sprawling multifamily apartment complex with multiple buildings, courtyards, parking, and a pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/01-2355 N Hwy 360 -9.jpg"
    },
    {
      "id": "ec_e130ff0f94a585f52c86cdad",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dc-ed0d-726f-aff0-1f34c146fb89.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex with swimming pool and lake in background.",
        "public_id": "01a0b5dc-ed0d-726f-aff0-1f34c146fb89",
        "storage_key": "property/6767906449167591/01a0b5dc-ed0d-726f-aff0-1f34c146fb89.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Expansive aerial view showcases the apartment complex amenities, including a sparkling swimming pool, surrounded by lush greenery and overlooking a serene lake.",
      "link": "false",
      "alt_text": "Aerial view of apartment complex with swimming pool and lake in background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/02-2355 N Hwy 360 -7.jpg"
    },
    {
      "id": "ec_c68d3ea24f09db36941dcfc5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dc-d6aa-728c-92db-855616a834f4.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings and a large office building near a lake.",
        "public_id": "01a0b5dc-d6aa-728c-92db-855616a834f4",
        "storage_key": "property/6767906449167591/01a0b5dc-d6aa-728c-92db-855616a834f4.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "An aerial view showcases a vast community of apartment complexes and a prominent office building, set against the backdrop of a serene lake and surrounding landscape.",
      "link": "false",
      "alt_text": "Aerial view of apartment buildings and a large office building near a lake.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/03-2355 N Hwy 360 -8.jpg"
    },
    {
      "id": "ec_5c3d779306b19aa7c30f3eb1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dc-d967-7742-b1f6-a91fc1116a24.webp",
      "image_media": {
        "alt_text": "Community lounge with pool table, seating, and dining area.",
        "public_id": "01a0b5dc-d967-7742-b1f6-a91fc1116a24",
        "storage_key": "property/6767906449167591/01a0b5dc-d967-7742-b1f6-a91fc1116a24.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy leisure time in the community lounge, featuring a billiards table, comfortable seating, and a dining area perfect for gatherings.",
      "link": "false",
      "alt_text": "Community lounge with pool table, seating, and dining area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/07-2355 N Hwy 360 -3.jpg"
    },
    {
      "id": "ec_5003112aa27b5fbeee5120c6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dc-f4eb-758a-b6a8-c11d1246f39e.webp",
      "image_media": {
        "alt_text": "Treadmills, ellipticals, and weight machines in a well-lit fitness center.",
        "public_id": "01a0b5dc-f4eb-758a-b6a8-c11d1246f39e",
        "storage_key": "property/6767906449167591/01a0b5dc-f4eb-758a-b6a8-c11d1246f39e.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with cardio machines and free weights to help you achieve your wellness goals.",
      "link": "false",
      "alt_text": "Treadmills, ellipticals, and weight machines in a well-lit fitness center.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/06-2355 N Hwy 360 -2.jpg"
    },
    {
      "id": "ec_bbaed583417a6a18fb2991c5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dc-e12a-742a-aa48-00156bc64a01.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical machines, and weight machines.",
        "public_id": "01a0b5dc-e12a-742a-aa48-00156bc64a01",
        "storage_key": "property/6767906449167591/01a0b5dc-e12a-742a-aa48-00156bc64a01.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines and strength training equipment.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, elliptical machines, and weight machines.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/05-2355 N Hwy 360 -1.jpg"
    },
    {
      "id": "ec_b641dfe8083688afda1d5203",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dc-e1d0-74ed-b011-43049cd0eee6.webp",
      "image_media": {
        "alt_text": "Billiard table in a lounge area with seating and a television.",
        "public_id": "01a0b5dc-e1d0-74ed-b011-43049cd0eee6",
        "storage_key": "property/6767906449167591/01a0b5dc-e1d0-74ed-b011-43049cd0eee6.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy a game of billiards in the community lounge, complete with comfortable seating and entertainment options.",
      "link": "false",
      "alt_text": "Billiard table in a lounge area with seating and a television.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/08-2355 N Hwy 360 -4.jpg"
    },
    {
      "id": "ec_92f79cf859ae43d145f09aa4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dc-e32c-72e5-8874-92c23e42f1b5.webp",
      "image_media": {
        "alt_text": "Business center with two computers and printers",
        "public_id": "01a0b5dc-e32c-72e5-8874-92c23e42f1b5",
        "storage_key": "property/6767906449167591/01a0b5dc-e32c-72e5-8874-92c23e42f1b5.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Utilize the community business center, complete with computers and printers, for all your professional needs.",
      "link": "false",
      "alt_text": "Business center with two computers and printers",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/09-2355 N Hwy 360 -5.jpg"
    },
    {
      "id": "ec_56fdedc3825df7d5a8d5edce",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dc-ea3e-75f8-83ec-3f7c58305fe9.webp",
      "image_media": {
        "alt_text": "Modern living and dining room area with gray furniture, a TV, and a dining table.",
        "public_id": "01a0b5dc-ea3e-75f8-83ec-3f7c58305fe9",
        "storage_key": "property/6767906449167591/01a0b5dc-ea3e-75f8-83ec-3f7c58305fe9.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious and elegantly furnished living and dining area, perfect for relaxing and entertaining. Features comfortable seating, a large TV, and a modern dining set.",
      "link": "false",
      "alt_text": "Modern living and dining room area with gray furniture, a TV, and a dining table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/10-2355 N Hwy 360 -11_final.jpg"
    },
    {
      "id": "ec_f7a33a2d0e58fddab78fa299",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dc-eac0-7010-a404-1803999e25bc.webp",
      "image_media": {
        "alt_text": "Open-concept living and dining area with a kitchen view. Features a sofa, coffee table, dining table, and TV.",
        "public_id": "01a0b5dc-eac0-7010-a404-1803999e25bc",
        "storage_key": "property/6767906449167591/01a0b5dc-eac0-7010-a404-1803999e25bc.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious open-concept living, dining, and kitchen area, perfect for entertaining. Enjoy comfortable seating and a modern aesthetic.",
      "link": "false",
      "alt_text": "Open-concept living and dining area with a kitchen view. Features a sofa, coffee table, dining table, and TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/14-2355 N Hwy 360 -13_final.jpg"
    },
    {
      "id": "ec_e9da0ec282f0a099bcae993f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dc-eccc-753b-8d8a-ec6be923b7bb.webp",
      "image_media": {
        "alt_text": "Living room and dining area with fireplace, mounted TV, and bar seating.",
        "public_id": "01a0b5dc-eccc-753b-8d8a-ec6be923b7bb",
        "storage_key": "property/6767906449167591/01a0b5dc-eccc-753b-8d8a-ec6be923b7bb.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a fireplace and mounted TV, adjacent to a dining area with bar seating and a glimpse of the kitchen.",
      "link": "false",
      "alt_text": "Living room and dining area with fireplace, mounted TV, and bar seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/45-2355 N Hwy 360 -36_final.jpg"
    },
    {
      "id": "ec_09f990dbccb2883031b4ec3a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dc-f3f8-7629-859d-88b5ac582960.webp",
      "image_media": {
        "alt_text": "Dining area with a round table and chairs, two windows with blinds.",
        "public_id": "01a0b5dc-f3f8-7629-859d-88b5ac582960",
        "storage_key": "property/6767906449167591/01a0b5dc-f3f8-7629-859d-88b5ac582960.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Apartment",
      "description": "Enjoy your meals in this cozy dining area, featuring a stylish round table and chairs by the window.",
      "link": "false",
      "alt_text": "Dining area with a round table and chairs, two windows with blinds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/51-2355 N Hwy 360 -39_final.jpg"
    },
    {
      "id": "ec_33f4ed35012224d4a288165f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dc-f494-706c-9668-09e961f5ecc4.webp",
      "image_media": {
        "alt_text": "Kitchen with light wood cabinets, white appliances including a microwave, oven, and refrigerator, and a sink with a bowl of fruit.",
        "public_id": "01a0b5dc-f494-706c-9668-09e961f5ecc4",
        "storage_key": "property/6767906449167591/01a0b5dc-f494-706c-9668-09e961f5ecc4.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring light wood cabinetry, a microwave, oven, refrigerator, and a double sink. Perfect for preparing meals.",
      "link": "false",
      "alt_text": "Kitchen with light wood cabinets, white appliances including a microwave, oven, and refrigerator, and a sink with a bowl of fruit.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/63-2355 N Hwy 360 -58.jpg"
    },
    {
      "id": "ec_7f5fbfc2bdd4f42e50184e1c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dc-f5ba-72ea-b492-116d74563e2b.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, decorative pillows, and a pink throw blanket.",
        "public_id": "01a0b5dc-f5ba-72ea-b492-116d74563e2b",
        "storage_key": "property/6767906449167591/01a0b5dc-f5ba-72ea-b492-116d74563e2b.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Apartment",
      "description": "Relax in this comfortable bedroom, featuring a plush king-size bed and elegant decor. Perfect for unwinding after a long day.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, decorative pillows, and a pink throw blanket.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/22-2355 N Hwy 360 -17_final.jpg"
    },
    {
      "id": "ec_1058c51dd51e5803a079aab9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dd-0c4b-714b-96d3-5eac17f28638.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, nightstands, and a ceiling fan.",
        "public_id": "01a0b5dd-0c4b-714b-96d3-5eac17f28638",
        "storage_key": "property/6767906449167591/01a0b5dd-0c4b-714b-96d3-5eac17f28638.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Relax in this spacious bedroom, featuring a comfortable bed and ample natural light from the large window.",
      "link": "false",
      "alt_text": "Bedroom with a large bed, nightstands, and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/16-2355 N Hwy 360 -14_final.jpg"
    },
    {
      "id": "ec_f8239182b3fabc4a43f25eb6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dc-fd30-7338-800a-f9a6768caec3.webp",
      "image_media": {
        "alt_text": "Living room area with two plush chairs, a side table, and a ceiling fan.",
        "public_id": "01a0b5dc-fd30-7338-800a-f9a6768caec3",
        "storage_key": "property/6767906449167591/01a0b5dc-fd30-7338-800a-f9a6768caec3.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Relax in this cozy living area, perfect for unwinding after a long day. Featuring comfortable seating and a ceiling fan for added comfort.",
      "link": "false",
      "alt_text": "Living room area with two plush chairs, a side table, and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/47-2355 N Hwy 360 -37_final.jpg"
    },
    {
      "id": "ec_2616df83d0569768d2cd039f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dc-fdd8-749f-bbea-09b4ffec2562.webp",
      "image_media": {
        "alt_text": "Bedroom with a king size bed, ceiling fan, and mounted TV.",
        "public_id": "01a0b5dc-fdd8-749f-bbea-09b4ffec2562",
        "storage_key": "property/6767906449167591/01a0b5dc-fdd8-749f-bbea-09b4ffec2562.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king size bed, modern ceiling fan, and wall-mounted television. Enjoy a relaxing retreat in this well-appointed living space.",
      "link": "false",
      "alt_text": "Bedroom with a king size bed, ceiling fan, and mounted TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/28-2355 N Hwy 360 -20_final.jpg"
    },
    {
      "id": "ec_f27a97b6c467428c18743318",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dd-1481-758f-bf47-dac6e0122736.webp",
      "image_media": {
        "alt_text": "Spacious walk-in closet with wire shelving and organized clothing.",
        "public_id": "01a0b5dd-1481-758f-bf47-dac6e0122736",
        "storage_key": "property/6767906449167591/01a0b5dd-1481-758f-bf47-dac6e0122736.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Ample walk-in closet space with built-in wire shelving, perfect for organizing your wardrobe. Keep your clothes neatly stored and easily accessible.",
      "link": "false",
      "alt_text": "Spacious walk-in closet with wire shelving and organized clothing.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/20-2355 N Hwy 360 -16_final.jpg"
    },
    {
      "id": "ec_7566c2e168014b4bc091d421",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dd-147e-702f-b5da-01cfbdc09efe.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a king-size bed, featuring blue and white bedding, decorative pillows, and two framed mountain landscape pictures on the wall.",
        "public_id": "01a0b5dd-147e-702f-b5da-01cfbdc09efe",
        "storage_key": "property/6767906449167591/01a0b5dd-147e-702f-b5da-01cfbdc09efe.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Relax in comfort in this inviting bedroom, complete with a plush king-size bed, stylish decor, and ample natural light from the large window. Perfect for unwinding after a long day.",
      "link": "false",
      "alt_text": "Cozy bedroom with a king-size bed, featuring blue and white bedding, decorative pillows, and two framed mountain landscape pictures on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/24-2355 N Hwy 360 -18_final.jpg"
    },
    {
      "id": "ec_cb30e0af1a489ccc341c5e31",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dd-0629-71b3-ae74-0e3f80f064af.webp",
      "image_media": {
        "alt_text": "Double vanity with dark wood cabinets, granite countertops, two sinks, and a large mirror. A closet is visible to the left.",
        "public_id": "01a0b5dd-0629-71b3-ae74-0e3f80f064af",
        "storage_key": "property/6767906449167591/01a0b5dd-0629-71b3-ae74-0e3f80f064af.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Experience the convenience of a double vanity in your bathroom, featuring ample storage with dark wood cabinets and elegant granite countertops. A spacious closet is also included.",
      "link": "false",
      "alt_text": "Double vanity with dark wood cabinets, granite countertops, two sinks, and a large mirror. A closet is visible to the left.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/55-2355 N Hwy 360 -22.jpg"
    },
    {
      "id": "ec_ae3157d411687b0305b80b6c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dd-0814-724a-8c53-2829994e8851.webp",
      "image_media": {
        "alt_text": "Pet-friendly amenities including a dog bed and 'love' sign.",
        "public_id": "01a0b5dd-0814-724a-8c53-2829994e8851",
        "storage_key": "property/6767906449167591/01a0b5dd-0814-724a-8c53-2829994e8851.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Discover our pet-friendly community with amenities designed for your furry friends, including a comfortable dog bed and a charming 'love' sign.",
      "link": "false",
      "alt_text": "Pet-friendly amenities including a dog bed and 'love' sign.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/66-2355 N Hwy 360 -57.jpg"
    },
    {
      "id": "ec_cfa6b05f9fef2bdd017e6b6a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dd-1230-735d-a44e-a9a7ad81f0ea.webp",
      "image_media": {
        "alt_text": "Comfortable seating area with two accent chairs and a small dining table by large windows.",
        "public_id": "01a0b5dd-1230-735d-a44e-a9a7ad81f0ea",
        "storage_key": "property/6767906449167591/01a0b5dd-1230-735d-a44e-a9a7ad81f0ea.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Relax in this charming seating area, perfect for reading or enjoying a quiet moment. Features plush accent chairs and a small dining set near large windows.",
      "link": "false",
      "alt_text": "Comfortable seating area with two accent chairs and a small dining table by large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/49-2355 N Hwy 360 -38_final.jpg"
    },
    {
      "id": "ec_495724725a1cafb2bad7e3d9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dd-2bc2-7529-9d81-eda31d564ee3.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area of an apartment",
        "public_id": "01a0b5dd-2bc2-7529-9d81-eda31d564ee3",
        "storage_key": "property/6767906449167591/01a0b5dd-2bc2-7529-9d81-eda31d564ee3.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious living room and kitchen area featuring an open-concept design, perfect for entertaining.",
      "link": "false",
      "alt_text": "Living room and kitchen area of an apartment",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/53-2355 N Hwy 360 -41_final.jpg"
    },
    {
      "id": "ec_fc206ff047be8e19090daaf9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dd-1b6a-721b-b2ee-be26b7bd9ed1.webp",
      "image_media": {
        "alt_text": "Living room with sofa, coffee table, and dining area.",
        "public_id": "01a0b5dd-1b6a-721b-b2ee-be26b7bd9ed1",
        "storage_key": "property/6767906449167591/01a0b5dd-1b6a-721b-b2ee-be26b7bd9ed1.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a comfortable sofa, elegant coffee table, and a dedicated dining space. Perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Living room with sofa, coffee table, and dining area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/65-2355 N Hwy 360 -49.jpg"
    },
    {
      "id": "ec_84c94c34a65f70e2d89715e6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dd-3377-75cc-9825-9331c7cda30c.webp",
      "image_media": {
        "alt_text": "Bedroom with a large TV, dresser, and bed.",
        "public_id": "01a0b5dd-3377-75cc-9825-9331c7cda30c",
        "storage_key": "property/6767906449167591/01a0b5dd-3377-75cc-9825-9331c7cda30c.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a mounted TV, a stylish dresser with decorative items, and a comfortable bed with blue and yellow accents.",
      "link": "false",
      "alt_text": "Bedroom with a large TV, dresser, and bed.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/30-2355 N Hwy 360 -21_final.jpg"
    },
    {
      "id": "ec_cc5eae4b37b39989de162fb3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dd-33a8-732b-a239-0859d62c5a91.webp",
      "image_media": {
        "alt_text": "Dining area with a round table and chairs next to a kitchen counter with a microwave.",
        "public_id": "01a0b5dd-33a8-732b-a239-0859d62c5a91",
        "storage_key": "property/6767906449167591/01a0b5dd-33a8-732b-a239-0859d62c5a91.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Enjoy a meal in your bright dining area, conveniently located next to your kitchen, perfect for easy entertaining.",
      "link": "false",
      "alt_text": "Dining area with a round table and chairs next to a kitchen counter with a microwave.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/32-2355 N Hwy 360 -24_final.jpg"
    },
    {
      "id": "ec_dca8dd8844966b4172c131b3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dd-3370-7708-b6f7-4090daae6efc.webp",
      "image_media": {
        "alt_text": "Kitchen with dual sink, dishwasher, and pass-through to living area.",
        "public_id": "01a0b5dd-3370-7708-b6f7-4090daae6efc",
        "storage_key": "property/6767906449167591/01a0b5dd-3370-7708-b6f7-4090daae6efc.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring a dual sink, dishwasher, and ample counter space, perfect for meal preparation and entertaining.",
      "link": "false",
      "alt_text": "Kitchen with dual sink, dishwasher, and pass-through to living area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/64-2355 N Hwy 360 -59.jpg"
    },
    {
      "id": "ec_045b925946c0a9be438771d7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dd-3b89-72de-a6af-333468c6f9a4.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink and toilet, bathtub with shower curtain.",
        "public_id": "01a0b5dd-3b89-72de-a6af-333468c6f9a4",
        "storage_key": "property/6767906449167591/01a0b5dd-3b89-72de-a6af-333468c6f9a4.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Apartment",
      "description": "Modern bathroom with a spacious vanity, a clean toilet, and a bathtub with a stylish shower curtain. Perfect for relaxing after a long day.",
      "link": "false",
      "alt_text": "Bathroom vanity with sink and toilet, bathtub with shower curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/79-2355 N Hwy 360 -56.jpg"
    },
    {
      "id": "ec_58e2add36dd3aa2cd5d01f89",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dd-34cc-736f-bd4d-f38dba33d2e9.webp",
      "image_media": {
        "alt_text": "Bathroom with double vanity, granite countertops, and walk-in closet.",
        "public_id": "01a0b5dd-34cc-736f-bd4d-f38dba33d2e9",
        "storage_key": "property/6767906449167591/01a0b5dd-34cc-736f-bd4d-f38dba33d2e9.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with granite countertops, ample cabinet storage, and a large walk-in closet for all your storage needs.",
      "link": "false",
      "alt_text": "Bathroom with double vanity, granite countertops, and walk-in closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/72-2355 N Hwy 360 -47.jpg"
    },
    {
      "id": "ec_d60e0ee05c3f0d5d975ab80a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dd-3e49-7613-8683-23f039e22360.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and glass-enclosed shower.",
        "public_id": "01a0b5dd-3e49-7613-8683-23f039e22360",
        "storage_key": "property/6767906449167591/01a0b5dd-3e49-7613-8683-23f039e22360.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "View of a bathroom featuring a vanity with a sink, a toilet, and a spacious glass-enclosed shower with white tile.",
      "link": "false",
      "alt_text": "Bathroom with vanity, toilet, and glass-enclosed shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/57-2355 N Hwy 360 -26.jpg"
    },
    {
      "id": "ec_5c6cc0b47920469a78f20f09",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dd-3eef-7479-88af-9d646232010e.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with double sinks, toilet, and closet",
        "public_id": "01a0b5dd-3eef-7479-88af-9d646232010e",
        "storage_key": "property/6767906449167591/01a0b5dd-3eef-7479-88af-9d646232010e.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a dual vanity with granite countertops, a separate toilet area, and a walk-in closet.",
      "link": "false",
      "alt_text": "Bathroom vanity with double sinks, toilet, and closet",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/73-2355 N Hwy 360 -48.jpg"
    },
    {
      "id": "ec_4fb93b53109a4a934200724f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dd-3fd6-724a-9e59-7ad9529b096f.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, dresser, mirror, and walk-in closet.",
        "public_id": "01a0b5dd-3fd6-724a-9e59-7ad9529b096f",
        "storage_key": "property/6767906449167591/01a0b5dd-3fd6-724a-9e59-7ad9529b096f.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed, a stylish dresser with a mirror, and ample storage in a walk-in closet.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, dresser, mirror, and walk-in closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/75-2355 N Hwy 360 -53.jpg"
    },
    {
      "id": "ec_c5bc1f37c2549e41dd090e26",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dd-40fc-728a-a6ff-1c6717252804.webp",
      "image_media": {
        "alt_text": "A bedroom with a closet and a dresser.",
        "public_id": "01a0b5dd-40fc-728a-a6ff-1c6717252804",
        "storage_key": "property/6767906449167591/01a0b5dd-40fc-728a-a6ff-1c6717252804.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a walk-in closet, a dresser with decorative items, and a ceiling fan.",
      "link": "false",
      "alt_text": "A bedroom with a closet and a dresser.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/18-2355 N Hwy 360 -15_final.jpg"
    },
    {
      "id": "ec_45d8cb372f2533fe2917ecd0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dd-5abe-7508-b9f1-dd6596a55963.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, dresser, and closet.",
        "public_id": "01a0b5dd-5abe-7508-b9f1-dd6596a55963",
        "storage_key": "property/6767906449167591/01a0b5dd-5abe-7508-b9f1-dd6596a55963.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, a large dresser with a mirror, and a walk-in closet, perfect for relaxation.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, dresser, and closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/74-2355 N Hwy 360 -52.jpg"
    },
    {
      "id": "ec_77909a5f44aec6aa0043ec5a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dd-48b6-74ae-b84e-7dc6f65e9bfd.webp",
      "image_media": {
        "alt_text": "Bedroom with king-size bed, dresser, and attached bathroom.",
        "public_id": "01a0b5dd-48b6-74ae-b84e-7dc6f65e9bfd",
        "storage_key": "property/6767906449167591/01a0b5dd-48b6-74ae-b84e-7dc6f65e9bfd.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, elegant decor, and convenient access to an attached bathroom.",
      "link": "false",
      "alt_text": "Bedroom with king-size bed, dresser, and attached bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/26-2355 N Hwy 360 -19_final.jpg"
    },
    {
      "id": "ec_5c9765220483fc4fdd8dbb6f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dd-497d-77d8-821d-353eff97fcc5.webp",
      "image_media": {
        "alt_text": "Living room and dining area with sofa, coffee table, and dining table.",
        "public_id": "01a0b5dd-497d-77d8-821d-353eff97fcc5",
        "storage_key": "property/6767906449167591/01a0b5dd-497d-77d8-821d-353eff97fcc5.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious living and dining area, perfect for entertaining or relaxing.",
      "link": "false",
      "alt_text": "Living room and dining area with sofa, coffee table, and dining table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12-2355 N Hwy 360 -12_final.jpg"
    },
    {
      "id": "ec_640189ea66536fdc29e0ecd5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5dd-49f6-738b-804b-1c4d3beca061.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee table, and entrance to kitchen.",
        "public_id": "01a0b5dd-49f6-738b-804b-1c4d3beca061",
        "storage_key": "property/6767906449167591/01a0b5dd-49f6-738b-804b-1c4d3beca061.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious living area with comfortable seating and an open view to the kitchen. Perfect for relaxing and entertaining.",
      "link": "false",
      "alt_text": "Living room with a sofa, coffee table, and entrance to kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/67-2355 N Hwy 360 -50.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_9d5c1c38-ca26-4e19-89ff-3544d4caa676",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Chapps Burgers (Hwy 360)",
      "poi_type": "Restaurants",
      "poi_address": "2045 N State Hwy 360 Service Rd W, Grand Prairie, TX 75050, USA",
      "poi_short_description": "Local counter-serve chain featuring a menu of burgers, sandwiches & hot dogs in a casual space.",
      "poi_long_description": "Local counter-serve chain featuring a menu of burgers, sandwiches & hot dogs in a casual space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc928-e0ed-7469-8fca-bf43b5e955f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc928-e0ed-7469-8fca-bf43b5e955f6",
        "storage_key": "property/6767906449167591/019fc928-e0ed-7469-8fca-bf43b5e955f6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.chappsburgers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6114609551881195904&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chapps-burgers-hwy-360",
      "poi_latitude": "32.7832756",
      "poi_longitude": "-97.0608519",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-649-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d37-72cb-8863-c1a28677bf83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d37-72cb-8863-c1a28677bf83",
        "storage_key": "property/6767906449167591/019fc925-7d37-72cb-8863-c1a28677bf83.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUZ774C2HToYRgNEWqP1021Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_a327a130-a67b-41ca-9687-9e8acee60e8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Schlotzsky's Deli",
      "poi_type": "Restaurants",
      "poi_address": "2035 N Hwy 360, Grand Prairie, TX 75050, USA",
      "poi_short_description": "Counter-serve chain serving deli fare, such as their Original sandwich, specialty pizzas & salads.",
      "poi_long_description": "Counter-serve chain serving deli fare, such as their Original sandwich, specialty pizzas & salads.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc928-e3b1-7348-8890-09c4c96a81d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc928-e3b1-7348-8890-09c4c96a81d7",
        "storage_key": "property/6767906449167591/019fc928-e3b1-7348-8890-09c4c96a81d7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.schlotzskys.com/tx/grand-prairie/2035-n-highway-360?utm_source=google&utm_medium=organic&utm_campaign=locations_partner",
      "poi_directions_map_url": "https://maps.google.com/?cid=13168917580847440935&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "schlotzskys-deli",
      "poi_latitude": "32.782405",
      "poi_longitude": "-97.0611664",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-617-2178",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d37-72cb-8863-c1a28677bf83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d37-72cb-8863-c1a28677bf83",
        "storage_key": "property/6767906449167591/019fc925-7d37-72cb-8863-c1a28677bf83.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlQ4Fc-KHToYRJ-TOksRkwbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "custom_0a1d6fb7-8c62-4320-a319-d04eea5ef317",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "IHOP",
      "poi_type": "Restaurants",
      "poi_address": "2060 N Hwy 360, Grand Prairie, TX 75050, USA",
      "poi_short_description": "Long-standing chain serving a wide variety of pancakes & other American breakfast & diner fare.",
      "poi_long_description": "Long-standing chain serving a wide variety of pancakes & other American breakfast & diner fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc928-e3f0-75c0-9ff7-6faedb5e761f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc928-e3f0-75c0-9ff7-6faedb5e761f",
        "storage_key": "property/6767906449167591/019fc928-e3f0-75c0-9ff7-6faedb5e761f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://restaurants.ihop.com/en-us/tx/grand-prairie/breakfast-2060-n-state-hwy-360-1411?utm_source=google&utm_medium=organic&utm_campaign=google_my_business&utm_term=1411&utm_content=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=12954860266049277463&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ihop",
      "poi_latitude": "32.784257",
      "poi_longitude": "-97.058783",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 972-647-8502",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d37-72cb-8863-c1a28677bf83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d37-72cb-8863-c1a28677bf83",
        "storage_key": "property/6767906449167591/019fc925-7d37-72cb-8863-c1a28677bf83.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCWHgcy6HToYRF46wMMboyLM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_e6bca7de-7e8d-4084-920e-48726c3cad27",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Whataburger",
      "poi_type": "Restaurants",
      "poi_address": "930 I-30 Frontage Rd, Grand Prairie, TX 75050, USA",
      "poi_short_description": "Circa-1950 fast-food chain for counter-serve burgers, some stacked with multiple patties.",
      "poi_long_description": "Circa-1950 fast-food chain for counter-serve burgers, some stacked with multiple patties.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5de-3132-734e-9335-834485985365.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b5de-3132-734e-9335-834485985365",
        "storage_key": "property/6767906449167591/01a0b5de-3132-734e-9335-834485985365.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.whataburger.com/tx/grand-prairie/930-e-interstate-highway-30.html/?utm_source=yextpages&utm_medium=locallistings&utm_campaign=yextpages",
      "poi_directions_map_url": "https://maps.google.com/?cid=1936586054184432797&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whataburger",
      "poi_latitude": "32.7596378",
      "poi_longitude": "-96.9935161",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-266-8740",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d37-72cb-8863-c1a28677bf83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d37-72cb-8863-c1a28677bf83",
        "storage_key": "property/6767906449167591/019fc925-7d37-72cb-8863-c1a28677bf83.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJG9PMezCEToYRnXSjfMEi4Bo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_a36b2f50-0b33-47b6-8112-9f2303dfc3e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Crazee Crab",
      "poi_type": "Restaurants",
      "poi_address": "5244 S State Hwy 360 Ste 340, Grand Prairie, TX 75052, USA",
      "poi_short_description": "Laid-back seafood joint with a nautical theme & TVs supplying down-home Cajun recipes & happy hours.",
      "poi_long_description": "Laid-back seafood joint with a nautical theme & TVs supplying down-home Cajun recipes & happy hours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5de-2a7e-7289-af8c-331891bee7a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b5de-2a7e-7289-af8c-331891bee7a7",
        "storage_key": "property/6767906449167591/01a0b5de-2a7e-7289-af8c-331891bee7a7.webp",
        "width": 1280,
        "height": 1102
      },
      "poi_business_url": "http://www.thecrazeecrab.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4389899175229212238&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crazee-crab",
      "poi_latitude": "32.6455563",
      "poi_longitude": "-97.0613165",
      "poi_miles_from_property": "12.2",
      "poi_walking_minutes": "4 hours 34 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 972-641-8866",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d37-72cb-8863-c1a28677bf83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d37-72cb-8863-c1a28677bf83",
        "storage_key": "property/6767906449167591/019fc925-7d37-72cb-8863-c1a28677bf83.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJV7GxPLCJToYRTkZRiwoO7Dw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_bb80a1f7-ecd6-4c48-b277-42bee2b77300",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "2490 I-20 Frontage Rd, Grand Prairie, TX 75052, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5de-2b55-7396-980c-d3e3ccad44f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b5de-2b55-7396-980c-d3e3ccad44f9",
        "storage_key": "property/6767906449167591/01a0b5de-2b55-7396-980c-d3e3ccad44f9.webp",
        "width": 1020,
        "height": 1280
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/texas/grand-prairie?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=5870086321769363118&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "32.6770497",
      "poi_longitude": "-97.037562",
      "poi_miles_from_property": "9.4",
      "poi_walking_minutes": "3 hours 31 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 972-206-0860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d37-72cb-8863-c1a28677bf83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d37-72cb-8863-c1a28677bf83",
        "storage_key": "property/6767906449167591/019fc925-7d37-72cb-8863-c1a28677bf83.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJGcrpIPOIToYRrjbxmWi8dlE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_a5e3a344-7b00-483e-a3d8-c509bbc4fcde",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Blue Goose Cantina Mexican Restaurant Grand Prairie",
      "poi_type": "Restaurants",
      "poi_address": "2536 I-20 Frontage Rd, Grand Prairie, TX 75052, USA",
      "poi_short_description": "Lively local cantina chain serving mesquite-grilled Tex-Mex fare, beer & margaritas.",
      "poi_long_description": "Lively local cantina chain serving mesquite-grilled Tex-Mex fare, beer & margaritas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5de-2d9a-742d-88f4-a15eb296152c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b5de-2d9a-742d-88f4-a15eb296152c",
        "storage_key": "property/6767906449167591/01a0b5de-2d9a-742d-88f4-a15eb296152c.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.bluegoosecantina.com/grand-prairie-tx/?utm_source=google&utm_medium=organic&utm_campaign=mybusiness_grand_prairie",
      "poi_directions_map_url": "https://maps.google.com/?cid=3237523174060036208&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-goose-cantina-mexican-restaurant-grand-prairie",
      "poi_latitude": "32.6774708",
      "poi_longitude": "-97.0419114",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 25 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 469-909-2583",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d37-72cb-8863-c1a28677bf83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d37-72cb-8863-c1a28677bf83",
        "storage_key": "property/6767906449167591/019fc925-7d37-72cb-8863-c1a28677bf83.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgYLbrG-JToYRcJDxdSz-7Sw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_98783f7b-929d-4f43-be53-b517d945d3f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Olive Garden Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "3138 S State Hwy 161, Grand Prairie, TX 75052, USA",
      "poi_short_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_long_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5de-2a87-749c-b6cc-f0d8c24e926d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b5de-2a87-749c-b6cc-f0d8c24e926d",
        "storage_key": "property/6767906449167591/01a0b5de-2a87-749c-b6cc-f0d8c24e926d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.olivegarden.com/locations/tx/grand-prairie/grand-prairie/6427?cmpid=br:og_ag:ie_ch:loc_ca:OGGMB_sn:gmb_gt:grand-prairie-tx-6427_pl:locurl_rd:1857",
      "poi_directions_map_url": "https://maps.google.com/?cid=4479611468920825301&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olive-garden-italian-restaurant",
      "poi_latitude": "32.6946884",
      "poi_longitude": "-97.0256696",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 13 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 972-352-2187",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d37-72cb-8863-c1a28677bf83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d37-72cb-8863-c1a28677bf83",
        "storage_key": "property/6767906449167591/019fc925-7d37-72cb-8863-c1a28677bf83.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJn6zGRBmJToYR1aXKoOXGKj4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_e29ab951-ebf4-45fb-a137-5e86389b0e5d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "The Finch",
      "poi_type": "Restaurants",
      "poi_address": "2955 S State Hwy 161, Grand Prairie, TX 75052, USA",
      "poi_short_description": "Relaxed venue pairing gourmet fare, beer and cocktails with waterfront views and friendly staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019ff6c7-14de-75f3-b972-84b355d214a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c7-14de-75f3-b972-84b355d214a3",
        "storage_key": "property/6767906449167591/019ff6c7-14de-75f3-b972-84b355d214a3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.thefinchgrandprairie.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5188243632306688085&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-finch",
      "poi_latitude": "32.702493",
      "poi_longitude": "-97.027727",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 469-480-6603",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d37-72cb-8863-c1a28677bf83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d37-72cb-8863-c1a28677bf83",
        "storage_key": "property/6767906449167591/019fc925-7d37-72cb-8863-c1a28677bf83.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJuVN73pmHToYRVZDSVxhYAEg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_f6d24ddf-c1ca-440e-83f3-05cc387be562",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Portillo's Grand Prairie",
      "poi_type": "Restaurants",
      "poi_address": "3102 State Hwy 161, Grand Prairie, TX 75052, USA",
      "poi_short_description": "Chicago-born chain for hot dogs, Italian beef sandwiches & more, plus beer & wine, in retro digs.",
      "poi_long_description": "Chicago-born chain for hot dogs, Italian beef sandwiches & more, plus beer & wine, in retro digs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5de-2a66-702c-bfcb-b613c837fa5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b5de-2a66-702c-bfcb-b613c837fa5a",
        "storage_key": "property/6767906449167591/01a0b5de-2a66-702c-bfcb-b613c837fa5a.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://locations.portillos.com/grand_prairie?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=14742286492341978004&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "portillos-grand-prairie",
      "poi_latitude": "32.6982138",
      "poi_longitude": "-97.0257186",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 469-506-0005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d37-72cb-8863-c1a28677bf83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d37-72cb-8863-c1a28677bf83",
        "storage_key": "property/6767906449167591/019fc925-7d37-72cb-8863-c1a28677bf83.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJg0SjPqeJToYRlEMV8XQfl8w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_1b4637fd-73f0-4af9-a005-9f9a74662622",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Chicken N Pickle - Grand Prairie",
      "poi_type": "Restaurants",
      "poi_address": "2965 State Hwy 161, Grand Prairie, TX 75052, USA",
      "poi_short_description": "Kid-friendly eatery featuring chicken burgers and cocktails in a rustic-chic space with pickleball courts and other outdoor games.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019ff6c7-15fc-73e9-8e12-0b02eed1a45e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c7-15fc-73e9-8e12-0b02eed1a45e",
        "storage_key": "property/6767906449167591/019ff6c7-15fc-73e9-8e12-0b02eed1a45e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://chickennpickle.com/location/grand-prairie/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9668087424046202720&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chicken-n-pickle---grand-prairie",
      "poi_latitude": "32.701606",
      "poi_longitude": "-97.025799",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 469-943-1410",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d37-72cb-8863-c1a28677bf83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d37-72cb-8863-c1a28677bf83",
        "storage_key": "property/6767906449167591/019fc925-7d37-72cb-8863-c1a28677bf83.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAYIoTyaHToYRYP-x10nyK4Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_0fc4104f-dd78-4450-a352-c6e4073af234",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Just Love Coffee Cafe - Grand Prairie",
      "poi_type": "Restaurants",
      "poi_address": "1020 Mayfield Rd Ste 600, Grand Prairie, TX 75052, USA",
      "poi_short_description": "Coffee shop offering signature lattes and other drinks along with comfort food in a casual space.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc928-e527-7201-b10f-88f5f6b968b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc928-e527-7201-b10f-88f5f6b968b3",
        "storage_key": "property/6767906449167591/019fc928-e527-7201-b10f-88f5f6b968b3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://justlovecoffeecafe.com/tx-grand-prairie/",
      "poi_directions_map_url": "https://maps.google.com/?cid=34571816381340895&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "just-love-coffee-cafe---grand-prairie",
      "poi_latitude": "32.6925743",
      "poi_longitude": "-97.0219126",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 972-639-3303",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc929-48c6-758a-bb89-e7e69dc0be71.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc929-48c6-758a-bb89-e7e69dc0be71",
        "storage_key": "property/6767906449167591/019fc929-48c6-758a-bb89-e7e69dc0be71.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ8YyIRniJToYR31ymQuLSegA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_521c21c4-a13c-482b-8379-813c430cdd91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Shell",
      "poi_type": "Transportation & Transit",
      "poi_address": "2095 N Hwy 360, Grand Prairie, TX 75050, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5de-3889-7268-8cf6-9cd46d1e1f38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b5de-3889-7268-8cf6-9cd46d1e1f38",
        "storage_key": "property/6767906449167591/01a0b5de-3889-7268-8cf6-9cd46d1e1f38.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://find.shell.com/us/fuel/10000847-2095-n-highway-360/en_US",
      "poi_directions_map_url": "https://maps.google.com/?cid=7311072985158609529&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shell",
      "poi_latitude": "32.7849706",
      "poi_longitude": "-97.0604868",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-633-9185",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc929-48ca-745d-a49b-50fa99ca28b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc929-48ca-745d-a49b-50fa99ca28b1",
        "storage_key": "property/6767906449167591/019fc929-48ca-745d-a49b-50fa99ca28b1.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJc6jy9y2HToYReWpV7yQmdmU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_a0ab4e76-2e34-4e5d-b857-bc72953153e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "2105 TX-360 Ste B, Grand Prairie, TX 75050, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019ff6c7-1798-739d-8660-e680d0d86ad2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c7-1798-739d-8660-e680d0d86ad2",
        "storage_key": "property/6767906449167591/019ff6c7-1798-739d-8660-e680d0d86ad2.webp",
        "width": 1280,
        "height": 746
      },
      "poi_business_url": "https://www.7-eleven.com/locations/tx/grand-prairie/2105-n-hwy-360-suite-b-26724?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=11990818711795223974&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "32.7859624",
      "poi_longitude": "-97.0603278",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 214-794-0176",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019ff6c7-4afd-7788-ae48-3ae18045b4f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6c7-4afd-7788-ae48-3ae18045b4f1",
        "storage_key": "property/6767906449167591/019ff6c7-4afd-7788-ae48-3ae18045b4f1.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJ51Vviy2HToYRpk2pmhbyZ6Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_1b13711c-c11b-4f9f-a453-cd09a30aee1b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "1622 N Hwy 360, Grand Prairie, TX 75050, USA",
      "poi_short_description": "Gas station and convenience store offering quick bites, beverages, and other travel necessities.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019ff6c7-1c05-7450-a102-8e722184a367.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c7-1c05-7450-a102-8e722184a367",
        "storage_key": "property/6767906449167591/019ff6c7-1c05-7450-a102-8e722184a367.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/grand-prairie/1622-n-state-hwy-360/2742176?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=9727424275203849363&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "32.77316390000001",
      "poi_longitude": "-97.0612783",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 972-641-1091",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019ff6c7-4afd-7788-ae48-3ae18045b4f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6c7-4afd-7788-ae48-3ae18045b4f1",
        "storage_key": "property/6767906449167591/019ff6c7-4afd-7788-ae48-3ae18045b4f1.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJXW6CWTuHToYRk3wJF9fA_oY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_e0cec83a-6e20-4ce2-a4a9-2db9af692909",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "2525 W Interstate 20, Grand Prairie, TX 75052, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc928-edcb-77ac-9042-f196051a2a0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc928-edcb-77ac-9042-f196051a2a0b",
        "storage_key": "property/6767906449167591/019fc928-edcb-77ac-9042-f196051a2a0b.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/tx/grand-prairie/great-southwest-pkwy/035/00817?cid=loc_03500817_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=13680496227624461861&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "32.6735798",
      "poi_longitude": "-97.0425902",
      "poi_miles_from_property": "9.4",
      "poi_walking_minutes": "3 hours 31 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 972-988-1335",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d39-747a-b149-c8e47260f94d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d39-747a-b149-c8e47260f94d",
        "storage_key": "property/6767906449167591/019fc925-7d39-747a-b149-c8e47260f94d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAb9vxPOIToYRJaagLtbi2r0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_edc1562b-a38d-4a11-9d44-356537449c6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "5270 S State Hwy 360, Grand Prairie, TX 75052, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc928-eee9-72ea-a25b-38c991d6f724.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc928-eee9-72ea-a25b-38c991d6f724",
        "storage_key": "property/6767906449167591/019fc928-eee9-72ea-a25b-38c991d6f724.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.target.com/sl/grand-prairie-s/2243",
      "poi_directions_map_url": "https://maps.google.com/?cid=8043718714718199624&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "32.6434",
      "poi_longitude": "-97.0597595",
      "poi_miles_from_property": "12.2",
      "poi_walking_minutes": "4 hours 35 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 469-348-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d41-70ce-98f1-fdd0f0bcfcea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d41-70ce-98f1-fdd0f0bcfcea",
        "storage_key": "property/6767906449167591/019fc925-7d41-70ce-98f1-fdd0f0bcfcea.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJvTcOTaWJToYRSJ_wt40HoW8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_7d7423b7-0b83-4d8e-920c-601e1da1eae7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "4203 S Carrier Pkwy, Grand Prairie, TX 75052, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc928-ee9a-7012-86de-e82d36a42e84.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc928-ee9a-7012-86de-e82d36a42e84",
        "storage_key": "property/6767906449167591/019fc928-ee9a-7012-86de-e82d36a42e84.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/grand-prairie-tx-pharmacies/4203-s-carrier-pkwy-grand-prairie-tx-75052/storeid=7809?WT.mc_id=LS_GOOGLE_RX_7809",
      "poi_directions_map_url": "https://maps.google.com/?cid=3307405247894795367&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "32.6713823",
      "poi_longitude": "-97.0049927",
      "poi_miles_from_property": "10.7",
      "poi_walking_minutes": "3 hours 59 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 972-642-3910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc929-48dc-721f-9676-fd4823a0ca02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc929-48dc-721f-9676-fd4823a0ca02",
        "storage_key": "property/6767906449167591/019fc929-48dc-721f-9676-fd4823a0ca02.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN1ku8DKPToYRZzQIsYxD5i0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_18a42437-2065-4525-8b8a-9d2c92430989",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "2325 I-20, Grand Prairie, TX 75052, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc928-f52c-759b-a538-f99d28ccb7d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc928-f52c-759b-a538-f99d28ccb7d5",
        "storage_key": "property/6767906449167591/019fc928-f52c-759b-a538-f99d28ccb7d5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.samsclub.com/club/8269-grand-prairie-tx",
      "poi_directions_map_url": "https://maps.google.com/?cid=2973133956446014436&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sams-club",
      "poi_latitude": "32.6735883",
      "poi_longitude": "-97.039705",
      "poi_miles_from_property": "9.6",
      "poi_walking_minutes": "3 hours 35 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 972-660-3405",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d41-70ce-98f1-fdd0f0bcfcea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d41-70ce-98f1-fdd0f0bcfcea",
        "storage_key": "property/6767906449167591/019fc925-7d41-70ce-98f1-fdd0f0bcfcea.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJo9J8fkq_ToYR5Mudv5SxQik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_658190c9-61e5-4abe-895d-5d4dd17701f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "IKEA",
      "poi_type": "Shopping & Retail",
      "poi_address": "1000 IKEA Wy, Grand Prairie, TX 75052, USA",
      "poi_short_description": "Scandinavian chain selling ready-to-assemble furniture, plus textiles, lighting & home decor.",
      "poi_long_description": "Scandinavian chain selling ready-to-assemble furniture, plus textiles, lighting & home decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5de-35eb-722a-9d4c-cbf0b07c3847.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b5de-35eb-722a-9d4c-cbf0b07c3847",
        "storage_key": "property/6767906449167591/01a0b5de-35eb-722a-9d4c-cbf0b07c3847.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.ikea.com/us/en/stores/grand-prairie/?utm_source=google&utm_medium=organic&utm_campaign=map&utm_content=grand-prairie",
      "poi_directions_map_url": "https://maps.google.com/?cid=414600180507258820&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ikea",
      "poi_latitude": "32.6906294",
      "poi_longitude": "-97.022627",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 20 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 888-888-4532",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d41-70ce-98f1-fdd0f0bcfcea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d41-70ce-98f1-fdd0f0bcfcea",
        "storage_key": "property/6767906449167591/019fc925-7d41-70ce-98f1-fdd0f0bcfcea.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJMTEHzzaJToYRxK_y4qr0wAU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_e4620491-acaa-4f7d-90ec-8e81c4446def",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Grand Prairie Premium Outlets",
      "poi_type": "Shopping & Retail",
      "poi_address": "2950 W Interstate 20, Grand Prairie, TX 75052, USA",
      "poi_short_description": "Discount shopping center featuring housewares, apparel, accessories & footwear stores, plus dining.",
      "poi_long_description": "Discount shopping center featuring housewares, apparel, accessories & footwear stores, plus dining.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0101b-385a-73cf-9383-d401a6fe03ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101b-385a-73cf-9383-d401a6fe03ea",
        "storage_key": "property/6767906449167591/01a0101b-385a-73cf-9383-d401a6fe03ea.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.premiumoutlets.com/outlet/grand-prairie",
      "poi_directions_map_url": "https://maps.google.com/?cid=10979929398224431444&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grand-prairie-premium-outlets",
      "poi_latitude": "32.6793757",
      "poi_longitude": "-97.0536398",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 972-602-8383",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d41-70ce-98f1-fdd0f0bcfcea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d41-70ce-98f1-fdd0f0bcfcea",
        "storage_key": "property/6767906449167591/019fc925-7d41-70ce-98f1-fdd0f0bcfcea.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJwaXgpWCIToYRVCkJEJ2LYJg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_04025c51-bc57-4001-bb04-83fadc3dbddc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Bass Pro Shops",
      "poi_type": "Shopping & Retail",
      "poi_address": "3720 S State Hwy 161, Grand Prairie, TX 75052, USA",
      "poi_short_description": "Chain known for its large, wilderness-themed stores & wide array of hunting, fishing & outdoor gear.",
      "poi_long_description": "Chain known for its large, wilderness-themed stores & wide array of hunting, fishing & outdoor gear.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0101b-3917-760f-9a0e-39bf3b83e331.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101b-3917-760f-9a0e-39bf3b83e331",
        "storage_key": "property/6767906449167591/01a0101b-3917-760f-9a0e-39bf3b83e331.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://stores.basspro.com/us/tx/grand-prairie/3720-s-state-highway-161.html?y_source=1_MTA1MDMyNTAxNi03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1756244504990198461&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bass-pro-shops",
      "poi_latitude": "32.6847213",
      "poi_longitude": "-97.021816",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "3 hours 29 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 469-928-2700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d41-70ce-98f1-fdd0f0bcfcea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d41-70ce-98f1-fdd0f0bcfcea",
        "storage_key": "property/6767906449167591/019fc925-7d41-70ce-98f1-fdd0f0bcfcea.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJfVWNJgCJToYRvSqsghJvXxg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_0ccaf670-7e21-45c8-98bc-2f4420f4399e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Eisenhower Elementary School",
      "poi_type": "Education",
      "poi_address": "2102 N Carrier Pkwy, Grand Prairie, TX 75050, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc928-f993-71cc-8978-b579201a1092.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc928-f993-71cc-8978-b579201a1092",
        "storage_key": "property/6767906449167591/019fc928-f993-71cc-8978-b579201a1092.webp",
        "width": 1280,
        "height": 1067
      },
      "poi_business_url": "http://www.gpisd.org/eisenhower",
      "poi_directions_map_url": "https://maps.google.com/?cid=13870852639368345162&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eisenhower-elementary-school",
      "poi_latitude": "32.7692615",
      "poi_longitude": "-97.0221301",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-262-3717",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d61-769d-a65b-02cbbc9220ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d61-769d-a65b-02cbbc9220ef",
        "storage_key": "property/6767906449167591/019fc925-7d61-769d-a65b-02cbbc9220ef.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJoW0mEZaGToYRSvZWDfwqf8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_1bcceb36-d400-42f1-9e5e-831000ad6b48",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Hector P. Garcia Elementary School",
      "poi_type": "Education",
      "poi_address": "2444 Graham St, Grand Prairie, TX 75050, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.gpisd.org/garcia",
      "poi_directions_map_url": "https://maps.google.com/?cid=13875679042401037329&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hector-p-garcia-elementary-school",
      "poi_latitude": "32.7569866",
      "poi_longitude": "-96.9685193",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-237-0001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d61-769d-a65b-02cbbc9220ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d61-769d-a65b-02cbbc9220ef",
        "storage_key": "property/6767906449167591/019fc925-7d61-769d-a65b-02cbbc9220ef.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjc6jsFaEToYREWylk5JQkMA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_6c40fd9a-92db-46cd-8b7a-e343337e07dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Crosswinds High School",
      "poi_type": "Education",
      "poi_address": "1100 N Carrier Pkwy, Grand Prairie, TX 75050, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc928-f993-71cc-8978-b579201a1092.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc928-f993-71cc-8978-b579201a1092",
        "storage_key": "property/6767906449167591/019fc928-f993-71cc-8978-b579201a1092.webp",
        "width": 1280,
        "height": 1067
      },
      "poi_business_url": "http://www.gpisd.org/crosswinds",
      "poi_directions_map_url": "https://maps.google.com/?cid=14004896797747206466&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crosswinds-high-school",
      "poi_latitude": "32.756213",
      "poi_longitude": "-97.018524",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 972-522-2950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d61-769d-a65b-02cbbc9220ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d61-769d-a65b-02cbbc9220ef",
        "storage_key": "property/6767906449167591/019fc925-7d61-769d-a65b-02cbbc9220ef.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcU0ado-GToYRQlm6uW9jW8I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_b3af04ff-5d8e-430c-9d37-64713fd606da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Grand Prairie High School",
      "poi_type": "Education",
      "poi_address": "101 Gopher Trail, Grand Prairie, TX 75050, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019ff6c7-1ebb-767f-b175-b0e64619f765.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c7-1ebb-767f-b175-b0e64619f765",
        "storage_key": "property/6767906449167591/019ff6c7-1ebb-767f-b175-b0e64619f765.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.gpisd.org/gphs",
      "poi_directions_map_url": "https://maps.google.com/?cid=4207278881641161262&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grand-prairie-high-school",
      "poi_latitude": "32.7532002",
      "poi_longitude": "-97.0020247",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-809-5711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d61-769d-a65b-02cbbc9220ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d61-769d-a65b-02cbbc9220ef",
        "storage_key": "property/6767906449167591/019fc925-7d61-769d-a65b-02cbbc9220ef.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJicBCeCmEToYRLmI5C9pBYzo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_f4b28f63-3140-42f0-8d19-e289f9082324",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Truman Middle School",
      "poi_type": "Education",
      "poi_address": "1501 Coffeyville Trail, Grand Prairie, TX 75052, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5de-38fc-72e7-b60a-0d7691ca2914.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b5de-38fc-72e7-b60a-0d7691ca2914",
        "storage_key": "property/6767906449167591/01a0b5de-38fc-72e7-b60a-0d7691ca2914.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://truman.gpisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4188045987739075048&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "truman-middle-school",
      "poi_latitude": "32.6542198",
      "poi_longitude": "-97.0225672",
      "poi_miles_from_property": "11.7",
      "poi_walking_minutes": "4 hours 23 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 972-641-7676",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d61-769d-a65b-02cbbc9220ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d61-769d-a65b-02cbbc9220ef",
        "storage_key": "property/6767906449167591/019fc925-7d61-769d-a65b-02cbbc9220ef.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJg0LBKCGJToYR6AEw-qLtHjo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_6b21fc1a-2d6e-458d-a8fb-7f96d3e9f0dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Earth Angels Pediatric Day Center, PPECC",
      "poi_type": "Health and Wellness",
      "poi_address": "2045 N Hwy 360 100 a, Grand Prairie, TX 75050, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0101b-3bd2-768a-8eab-d54bae37e44e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101b-3bd2-768a-8eab-d54bae37e44e",
        "storage_key": "property/6767906449167591/01a0101b-3bd2-768a-8eab-d54bae37e44e.webp",
        "width": 720,
        "height": 960
      },
      "poi_business_url": "https://www.sparkpediatrics.com/locations/grand-prairie-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=943029717471976128&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "earth-angels-pediatric-day-center-ppecc",
      "poi_latitude": "32.7830935",
      "poi_longitude": "-97.0617343",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 813-798-2809",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d61-769d-a65a-fdf52ce4c1fa",
        "storage_key": "property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBzkelfyHToYRwNqNGohQFg0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_776d9c22-1a3e-41dc-b9bc-b4f6a6bdc4ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Primrose School of NE Green Oaks",
      "poi_type": "Education",
      "poi_address": "1900 NE Green Oaks Blvd, Arlington, TX 76006, USA",
      "poi_short_description": "Informal learning center with caring staff, offering preschool, pre-kindergarten and after-school programs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc928-ffb9-730b-88de-fc2867e14429.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc928-ffb9-730b-88de-fc2867e14429",
        "storage_key": "property/6767906449167591/019fc928-ffb9-730b-88de-fc2867e14429.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.primroseschools.com/schools/ne-green-oaks/?utm_source=gbp&utm_medium=maplistings",
      "poi_directions_map_url": "https://maps.google.com/?cid=15809191360070741004&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primrose-school-of-ne-green-oaks",
      "poi_latitude": "32.775271",
      "poi_longitude": "-97.078923",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-543-2626",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d61-769d-a65b-02cbbc9220ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d61-769d-a65b-02cbbc9220ef",
        "storage_key": "property/6767906449167591/019fc925-7d61-769d-a65b-02cbbc9220ef.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJB74Gr0WHToYRDOwwA8iHZds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_a9bb63fc-5a26-46e0-9cdb-6ab6005f8f0b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Arlington Early Care and Education",
      "poi_type": "Education",
      "poi_address": "2501 Ballpark Way, Arlington, TX 76006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019ff6c7-1dff-77fd-b9bf-68c22940c362.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c7-1dff-77fd-b9bf-68c22940c362",
        "storage_key": "property/6767906449167591/019ff6c7-1dff-77fd-b9bf-68c22940c362.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://earlycareandeducation.com/arlington/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8129514865311453535&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arlington-early-care-and-education",
      "poi_latitude": "32.7776369",
      "poi_longitude": "-97.0739222",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-646-4522",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d61-769d-a65b-02cbbc9220ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d61-769d-a65b-02cbbc9220ef",
        "storage_key": "property/6767906449167591/019fc925-7d61-769d-a65b-02cbbc9220ef.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJBVKd1EeHToYRX5Elr7LW0XA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_7c0194e8-14a7-49e8-8975-c337168a7eda",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Concorde Career College - Grand Prairie",
      "poi_type": "Education",
      "poi_address": "3015 I-20, Grand Prairie, TX 75052, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5de-3ba9-75b7-8aee-74587481c2b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b5de-3ba9-75b7-8aee-74587481c2b8",
        "storage_key": "property/6767906449167591/01a0b5de-3ba9-75b7-8aee-74587481c2b8.webp",
        "width": 1280,
        "height": 956
      },
      "poi_business_url": "https://www.concorde.edu/campus/grand-prairie-texas?utm_source=google&utm_medium=organic&utm_campaign=knowledge&utm_term=grandprairie&SourceID=GO1106",
      "poi_directions_map_url": "https://maps.google.com/?cid=8767157706997643058&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "concorde-career-college---grand-prairie",
      "poi_latitude": "32.6755443",
      "poi_longitude": "-97.0550615",
      "poi_miles_from_property": "9.9",
      "poi_walking_minutes": "3 hours 43 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 469-532-0088",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d61-769d-a65b-02cbbc9220ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d61-769d-a65b-02cbbc9220ef",
        "storage_key": "property/6767906449167591/019fc925-7d61-769d-a65b-02cbbc9220ef.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJRfVfh5J9ToYRMjds73szq3k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_b18daead-7949-437f-8913-2443b11f1392",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Rayburn Elementary STEAM Academy",
      "poi_type": "Education",
      "poi_address": "2800 Reforma St, Grand Prairie, TX 75052, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc928-f993-71cc-8978-b579201a1092.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc928-f993-71cc-8978-b579201a1092",
        "storage_key": "property/6767906449167591/019fc928-f993-71cc-8978-b579201a1092.webp",
        "width": 1280,
        "height": 1067
      },
      "poi_business_url": "https://rayburn.gpisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9503174913999566058&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rayburn-elementary-steam-academy",
      "poi_latitude": "32.7025716",
      "poi_longitude": "-96.9892599",
      "poi_miles_from_property": "9.7",
      "poi_walking_minutes": "3 hours 34 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 972-264-8900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d61-769d-a65b-02cbbc9220ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d61-769d-a65b-02cbbc9220ef",
        "storage_key": "property/6767906449167591/019fc925-7d61-769d-a65b-02cbbc9220ef.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJO6D5FV-PToYR6vRY-zsP4oM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_07ab79ae-1d11-406d-9819-3c3663376c9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Epic Waters Indoor Waterpark",
      "poi_type": "Entertainment",
      "poi_address": "2970 Epic Place, Grand Prairie, TX 75052, USA",
      "poi_short_description": "Expansive, glass-enclosed waterpark with playful slides & pools, plus an arcade, gift shop & eatery.",
      "poi_long_description": "Expansive, glass-enclosed waterpark with playful slides & pools, plus an arcade, gift shop & eatery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc929-0010-76c8-be7d-dd9deaada0c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc929-0010-76c8-be7d-dd9deaada0c3",
        "storage_key": "property/6767906449167591/019fc929-0010-76c8-be7d-dd9deaada0c3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://epicwatersgp.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=849990701392178149&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "epic-waters-indoor-waterpark",
      "poi_latitude": "32.7020897",
      "poi_longitude": "-97.0315672",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 972-337-3131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d61-769d-a65a-fdf52ce4c1fa",
        "storage_key": "property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ76-SVh-GToYR5avdGgrGyws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_0e57dad1-df07-4d54-9eb2-40572f74a81c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "PlayGrand Adventures",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2100 Epic Pl, Grand Prairie, TX 75052, USA",
      "poi_short_description": "Massive playground featuring wheelchair-accessible swings and numerous climbing structures.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5de-3d64-754a-a908-26d78c98a3f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b5de-3d64-754a-a908-26d78c98a3f9",
        "storage_key": "property/6767906449167591/01a0b5de-3d64-754a-a908-26d78c98a3f9.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.playgrandadventures.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1296002551931779726&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "playgrand-adventures",
      "poi_latitude": "32.6994286",
      "poi_longitude": "-97.0338149",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 17 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 972-237-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d61-769d-a65a-fdf52ce4c1fa",
        "storage_key": "property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf9gYgZ6IToYRjrrkV3RT_BE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "playground"
    },
    {
      "id": "custom_e35e4eb7-9b9c-412f-9f5e-69e2745768f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Main Event Grand Prairie",
      "poi_type": "Restaurants",
      "poi_address": "3106 State Hwy 161, Grand Prairie, TX 75052, USA",
      "poi_short_description": "American fare, beer, wine and cocktails are served up at this chain venue for bowling and laser tag.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc929-0722-71ed-8d63-16b6af53ebfc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc929-0722-71ed-8d63-16b6af53ebfc",
        "storage_key": "property/6767906449167591/019fc929-0722-71ed-8d63-16b6af53ebfc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.mainevent.com/locations/texas/grand-prairie",
      "poi_directions_map_url": "https://maps.google.com/?cid=8556853843372624556&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "main-event-grand-prairie",
      "poi_latitude": "32.6969124",
      "poi_longitude": "-97.0266611",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 972-641-2695",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d37-72cb-8863-c1a28677bf83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d37-72cb-8863-c1a28677bf83",
        "storage_key": "property/6767906449167591/019fc925-7d37-72cb-8863-c1a28677bf83.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ45IjCKOJToYRrEopATwNwHY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_04f5e4e6-6faf-4d66-aed4-8fe47aa32dce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Andretti Indoor Karting & Games Grand Prairie",
      "poi_type": "Entertainment",
      "poi_address": "3750 State Hwy 161, Grand Prairie, TX 75052, USA",
      "poi_short_description": "Entertainment center with high-speed electric go karts, duckpin bowling, laser tag, and an arcade, plus a restaurant and a bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc929-0479-739c-a1cd-487aa98430aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc929-0479-739c-a1cd-487aa98430aa",
        "storage_key": "property/6767906449167591/019fc929-0479-739c-a1cd-487aa98430aa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.andrettikarting.com/grandprairie",
      "poi_directions_map_url": "https://maps.google.com/?cid=15761985197813368702&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "andretti-indoor-karting--games-grand-prairie",
      "poi_latitude": "32.6823676",
      "poi_longitude": "-97.0217442",
      "poi_miles_from_property": "9.5",
      "poi_walking_minutes": "3 hours 33 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 469-945-3278",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d61-769d-a65a-fdf52ce4c1fa",
        "storage_key": "property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5QkcBrCJToYRfoeh3gbSvdo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_a7483750-936a-4fc4-a94c-ae8d849119db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Topgolf Grand Prairie",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3670 S State Hwy 161, Grand Prairie, TX 75052, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc929-053f-7579-ab06-97c05124bdb5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc929-053f-7579-ab06-97c05124bdb5",
        "storage_key": "property/6767906449167591/019fc929-053f-7579-ab06-97c05124bdb5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://topgolf.com/us/grand-prairie/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7078161135624954829&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "topgolf-grand-prairie",
      "poi_latitude": "32.6860761",
      "poi_longitude": "-97.02147",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "3 hours 27 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 945-327-5201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d39-747a-b149-c68ec70073bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d39-747a-b149-c68ec70073bb",
        "storage_key": "property/6767906449167591/019fc925-7d39-747a-b149-c68ec70073bb.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3VOfDQCJToYRzaPmFw2uOmI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_11bddb9b-fe09-4ca3-8d65-eb7a04dd1f6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Ripley's Believe It or Not!",
      "poi_type": "Entertainment",
      "poi_address": "601 E Palace Pkwy, Grand Prairie, TX 75050, USA",
      "poi_short_description": "Museum with kitschy oddities on display, including shrunken human heads & rare animal skeletons.",
      "poi_long_description": "Museum with kitschy oddities on display, including shrunken human heads & rare animal skeletons.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc929-0dc6-772c-9831-b19229029cac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc929-0dc6-772c-9831-b19229029cac",
        "storage_key": "property/6767906449167591/019fc929-0dc6-772c-9831-b19229029cac.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.ripleys.com/attractions/ripleys-believe-it-or-not-grand-prairie",
      "poi_directions_map_url": "https://maps.google.com/?cid=7309889782508952814&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ripleys-believe-it-or-not",
      "poi_latitude": "32.7605415",
      "poi_longitude": "-97.0037093",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-263-2391",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d61-769d-a65a-fdf52ce4c1fa",
        "storage_key": "property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH9DONiaEToYR7hy0GQfycWU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "custom_7e17d51e-0e72-47e4-afd5-69dbdbc5e178",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Texas Trust CU Theatre",
      "poi_type": "Entertainment",
      "poi_address": "1001 Texas Trust Wy, Grand Prairie, TX 75050, USA",
      "poi_short_description": "An upscale 6,000-seat venue for music, Broadway & comedy productions, with luxury suite options.",
      "poi_long_description": "An upscale 6,000-seat venue for music, Broadway & comedy productions, with luxury suite options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc929-0288-70ab-ac29-224eda43e9e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc929-0288-70ab-ac29-224eda43e9e4",
        "storage_key": "property/6767906449167591/019fc929-0288-70ab-ac29-224eda43e9e4.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://texastrustcutheatre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5547210984445467107&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-trust-cu-theatre",
      "poi_latitude": "32.7668573",
      "poi_longitude": "-96.9823914",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 972-854-5050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d61-769d-a65a-fdf52ce4c1fa",
        "storage_key": "property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU_Waz0CEToYR41kE_v-m-0w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_ed9a90e9-bda8-4d91-9bce-4a5099d37146",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Lone Star Park",
      "poi_type": "Entertainment",
      "poi_address": "1000 Lone Star Pkwy, Grand Prairie, TX 75050, USA",
      "poi_short_description": "Horse racing track & concert venue offering dining facilities, plus private penthouse suites.",
      "poi_long_description": "Horse racing track & concert venue offering dining facilities, plus private penthouse suites.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5de-3d07-75ec-a4c3-480c1656c232.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b5de-3d07-75ec-a4c3-480c1656c232",
        "storage_key": "property/6767906449167591/01a0b5de-3d07-75ec-a4c3-480c1656c232.webp",
        "width": 1280,
        "height": 914
      },
      "poi_business_url": "http://www.lonestarpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7341660337807193448&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lone-star-park",
      "poi_latitude": "32.7725687",
      "poi_longitude": "-96.9882217",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 972-263-7223",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d61-769d-a65a-fdf52ce4c1fa",
        "storage_key": "property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiwxaWxWEToYRaHWS8C3R4mU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "race_course"
    },
    {
      "id": "custom_4bbf72f7-41d4-42c9-bafa-58febe2dea90",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Traders Village Grand Prairie",
      "poi_type": "Shopping & Retail",
      "poi_address": "2602 Mayfield Rd, Grand Prairie, TX 75052, USA",
      "poi_short_description": "Massive outdoor flea market with shopping, special events, rides & food vendors.",
      "poi_long_description": "Massive outdoor flea market with shopping, special events, rides & food vendors.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5de-3f41-73f9-8753-d9e811687f10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b5de-3f41-73f9-8753-d9e811687f10",
        "storage_key": "property/6767906449167591/01a0b5de-3f41-73f9-8753-d9e811687f10.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://tradersvillage.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6170447733089571556&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "traders-village-grand-prairie",
      "poi_latitude": "32.6953405",
      "poi_longitude": "-97.0512027",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 972-647-2331",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d41-70ce-98f1-fdd0f0bcfcea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d41-70ce-98f1-fdd0f0bcfcea",
        "storage_key": "property/6767906449167591/019fc925-7d41-70ce-98f1-fdd0f0bcfcea.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJA-5lkIeIToYR5BLrU4XVoVU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "flea_market"
    },
    {
      "id": "custom_6f418675-dd10-457b-bd63-d8c66272d9af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Uptown Theater in Grand Prairie",
      "poi_type": "Entertainment",
      "poi_address": "120 E Main St, Grand Prairie, TX 75050, USA",
      "poi_short_description": "Fully-restored 1950s performing arts center hosting national touring stage shows & concerts.",
      "poi_long_description": "Fully-restored 1950s performing arts center hosting national touring stage shows & concerts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc929-0010-76c8-be7d-e0c8731d07aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc929-0010-76c8-be7d-e0c8731d07aa",
        "storage_key": "property/6767906449167591/019fc929-0010-76c8-be7d-e0c8731d07aa.webp",
        "width": 800,
        "height": 267
      },
      "poi_business_url": "http://uptowntheatergp.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7871944576962194119&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uptown-theater-in-grand-prairie",
      "poi_latitude": "32.7458862",
      "poi_longitude": "-97.0024792",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-237-8786",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d61-769d-a65a-fdf52ce4c1fa",
        "storage_key": "property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn96XjtSFToYRx-pkqeLDPm0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_3e22b0cb-deb7-42da-b5aa-a30cec36cf18",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Texas Health Arlington Memorial Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "800 W Randol Mill Rd, Arlington, TX 76012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-6587-7222-af3d-57bbad8efdee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc925-6587-7222-af3d-57bbad8efdee",
        "storage_key": "property/6767906449167591/019fc925-6587-7222-af3d-57bbad8efdee.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.texashealth.org/locations/texas-health-arlington-memorial",
      "poi_directions_map_url": "https://maps.google.com/?cid=16779963323556390989&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-health-arlington-memorial-hospital",
      "poi_latitude": "32.7489891",
      "poi_longitude": "-97.1157765",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-960-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d41-70ce-98f1-f8886a816490.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d41-70ce-98f1-f8886a816490",
        "storage_key": "property/6767906449167591/019fc925-7d41-70ce-98f1-f8886a816490.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJK7oCFqJ9ToYRTWipHL1n3ug",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_370c4b54-3e74-4c93-bc03-075e187dde86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Concentra Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "2045 N Hwy 360 #100B, Grand Prairie, TX 75050, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc929-0d20-768a-909c-f6895efd10f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc929-0d20-768a-909c-f6895efd10f6",
        "storage_key": "property/6767906449167591/019fc929-0d20-768a-909c-f6895efd10f6.webp",
        "width": 728,
        "height": 351
      },
      "poi_business_url": "https://www.concentra.com/urgent-care-centers/texas/dallas/grand-prairie-urgent-care/#nearbylocations_g=32.7826989088%7C-97.0616158565&nearbylocations_o=DistanceMi%2CAscending&nearbylocations_distancemi=20&nearbylocations_DistanceMi=20",
      "poi_directions_map_url": "https://maps.google.com/?cid=15797704342742034083&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "concentra-urgent-care",
      "poi_latitude": "32.7828683",
      "poi_longitude": "-97.0617427",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 972-623-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d61-769d-a65a-fdf52ce4c1fa",
        "storage_key": "property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgcio5jGHToYRo-bIX2a4PNs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "doctor"
    },
    {
      "id": "custom_6de43804-9173-4723-ab64-502a4948f736",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Baylor Scott & White Urgent Care - Riverside",
      "poi_type": "Health and Wellness",
      "poi_address": "2740 TX-360 Ste 100A, Grand Prairie, TX 75050, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019ff6c7-275d-702e-a3fb-27f0f3bf5c25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c7-275d-702e-a3fb-27f0f3bf5c25",
        "storage_key": "property/6767906449167591/019ff6c7-275d-702e-a3fb-27f0f3bf5c25.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.bswhealth.com/locations/clinical-group/urgent-care-north-texas/riverside?utm_content=main-website&utm_source=pg-google&utm_medium=organic&utm_campaign=29985-9717447",
      "poi_directions_map_url": "https://maps.google.com/?cid=7313048625797095757&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baylor-scott--white-urgent-care---riverside",
      "poi_latitude": "32.7965945",
      "poi_longitude": "-97.0549852",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-912-8605",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d61-769d-a65a-fdf52ce4c1fa",
        "storage_key": "property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn3ssEZOBToYRTWHLnfoqfWU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_1893145c-43e7-44a1-97df-11e309f2c76d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Tom Thumb Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "4215 S Carrier Pkwy, Grand Prairie, TX 75052, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5de-3f9d-767c-987d-7dce496a3d0f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b5de-3f9d-767c-987d-7dce496a3d0f",
        "storage_key": "property/6767906449167591/01a0b5de-3f9d-767c-987d-7dce496a3d0f.webp",
        "width": 1280,
        "height": 955
      },
      "poi_business_url": "https://local.pharmacy.tomthumb.com/tx/grand-prairie/4215-s-carrier-pkwy.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=7275548108227337006&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tom-thumb-pharmacy",
      "poi_latitude": "32.6713018",
      "poi_longitude": "-97.003332",
      "poi_miles_from_property": "10.8",
      "poi_walking_minutes": "4 hours 2 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 972-266-7056",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc929-48dc-721f-9676-fd4823a0ca02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc929-48dc-721f-9676-fd4823a0ca02",
        "storage_key": "property/6767906449167591/019fc929-48dc-721f-9676-fd4823a0ca02.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr-q0YDKPToYRLtsn-XTw92Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_906697de-9858-4d77-a388-b020286570cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2225 W Interstate 20, Grand Prairie, TX 75052, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019ff6c7-2b25-768e-95ac-a0ada594399b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c7-2b25-768e-95ac-a0ada594399b",
        "storage_key": "property/6767906449167591/019ff6c7-2b25-768e-95ac-a0ada594399b.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.walmart.com/store/896-grand-prairie-tx/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=11252441596352704540&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "32.6735323",
      "poi_longitude": "-97.0362342",
      "poi_miles_from_property": "9.8",
      "poi_walking_minutes": "3 hours 39 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 972-660-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc929-48dc-721f-9676-fd4823a0ca02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc929-48dc-721f-9676-fd4823a0ca02",
        "storage_key": "property/6767906449167591/019fc929-48dc-721f-9676-fd4823a0ca02.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpRZiJeyIToYRHLBujgO0KJw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_c343a707-254f-4291-8428-af1fb199f015",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "541 W Pioneer Pkwy, Grand Prairie, TX 75051, USA",
      "poi_short_description": "Clean gym with a hydro massage bed offering cardio machines, saunas and weight-lifting equipment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-5dbc-72cc-818d-67b248ef10df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc925-5dbc-72cc-818d-67b248ef10df",
        "storage_key": "property/6767906449167591/019fc925-5dbc-72cc-818d-67b248ef10df.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/grand-prairie-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=1229411639399349918&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "32.7087252",
      "poi_longitude": "-97.0104486",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 682-348-0896",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d61-769d-a65a-fdf52ce4c1fa",
        "storage_key": "property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_QgVuwaGToYRnv4gUV-_DxE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c0bf5f1c-81e2-4056-8590-c04f12a264b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2360 W Camp Wisdom Rd Ste 190, Grand Prairie, TX 75052, USA",
      "poi_short_description": "Clean and comfortable atmosphere at this 24-hour gym offering personal training.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc929-1880-751d-9d6b-8dfc4fadf342.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc929-1880-751d-9d6b-8dfc4fadf342",
        "storage_key": "property/6767906449167591/019fc929-1880-751d-9d6b-8dfc4fadf342.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/grand-prairie-texas-4234/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=4234",
      "poi_directions_map_url": "https://maps.google.com/?cid=10938927458553560869&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "32.648777",
      "poi_longitude": "-97.0417251",
      "poi_miles_from_property": "11.2",
      "poi_walking_minutes": "4 hours 11 mins",
      "poi_biking_minutes": "1 hour 15 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 469-340-4367",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d61-769d-a65a-fdf52ce4c1fa",
        "storage_key": "property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM4GPILqJToYRJf_ZDpHgzpc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e131a873-9e2f-479e-9ccf-302ba08422fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "HOTWORX - Grand Prairie, TX",
      "poi_type": "Health and Wellness",
      "poi_address": "3166 State Hwy 161 #185, Grand Prairie, TX 75052, USA",
      "poi_short_description": "Casual fitness studio equipped with 24-hour access using infrared heat for workouts ranging from yoga to cycling, plus saunas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc929-126f-7182-a022-c7b1f1261852.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc929-126f-7182-a022-c7b1f1261852",
        "storage_key": "property/6767906449167591/019fc929-126f-7182-a022-c7b1f1261852.webp",
        "width": 554,
        "height": 312
      },
      "poi_business_url": "https://www.hotworx.net/studio/grandprairie?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=18162850923551194557&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hotworx---grand-prairie-tx",
      "poi_latitude": "32.6920852",
      "poi_longitude": "-97.0279006",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 17 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 972-895-2083",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d61-769d-a65b-02cbbc9220ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d61-769d-a65b-02cbbc9220ef",
        "storage_key": "property/6767906449167591/019fc925-7d61-769d-a65b-02cbbc9220ef.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJp3YKZASJToYRvf2kHq9oD_w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_c4818a9b-afcc-4603-866a-741540c33d12",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Diana's School of Yoga",
      "poi_type": "Health and Wellness",
      "poi_address": "925 W Pioneer Pkwy Ste k, Grand Prairie, TX 75051, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5de-415c-7774-ae2a-a9868e8ff9ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b5de-415c-7774-ae2a-a9868e8ff9ba",
        "storage_key": "property/6767906449167591/01a0b5de-415c-7774-ae2a-a9868e8ff9ba.webp",
        "width": 800,
        "height": 450
      },
      "poi_business_url": "http://www.dianasschoolofyoga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4576051152674157190&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dianas-school-of-yoga",
      "poi_latitude": "32.7089934",
      "poi_longitude": "-97.0185176",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 817-909-6544",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d61-769d-a65b-02cbbc9220ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d61-769d-a65b-02cbbc9220ef",
        "storage_key": "property/6767906449167591/019fc925-7d61-769d-a65b-02cbbc9220ef.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJx71ytgSGToYRhvIoRUdmgT8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_1f4baa87-224b-4fb6-aa08-14db82938358",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Fish Creek Linear Park West",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Fish Creek Trail, Grand Prairie, TX 75052, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc929-1cf8-77fd-8217-3aeaec6c8c93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc929-1cf8-77fd-8217-3aeaec6c8c93",
        "storage_key": "property/6767906449167591/019fc929-1cf8-77fd-8217-3aeaec6c8c93.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15051489766831352318&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fish-creek-linear-park-west",
      "poi_latitude": "32.6598945",
      "poi_longitude": "-97.0453135",
      "poi_miles_from_property": "10.4",
      "poi_walking_minutes": "3 hours 53 mins",
      "poi_biking_minutes": "1 hour 13 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d57-7377-98aa-ee7b8900f493.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d57-7377-98aa-ee7b8900f493",
        "storage_key": "property/6767906449167591/019fc925-7d57-7377-98aa-ee7b8900f493.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJAZo80wSJToYR_uloXDKi4dA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f5f849cd-f0e9-401f-aa51-4b8b156bf8be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Central Bark Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7445, 2222 W Warrior Trl, Grand Prairie, TX 75052, USA",
      "poi_short_description": "Spacious, fenced space for puppies and grown canines to exercise, with agility toys too.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc929-1991-779b-8c86-16fe3a9cf8d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc929-1991-779b-8c86-16fe3a9cf8d4",
        "storage_key": "property/6767906449167591/019fc929-1991-779b-8c86-16fe3a9cf8d4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://grandfungp.com/central-bark/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3814250617727292264&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-bark-dog-park",
      "poi_latitude": "32.6997826",
      "poi_longitude": "-97.0354639",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 17 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 972-237-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d57-7377-98aa-ee7b8900f493.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d57-7377-98aa-ee7b8900f493",
        "storage_key": "property/6767906449167591/019fc925-7d57-7377-98aa-ee7b8900f493.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJb21evJ2IToYRaBPzYbrw7jQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "custom_56bf08ea-f7ec-40d9-8a77-12088c7e264b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Lynn Creek Park at Joe Pool Lake",
      "poi_type": "Health and Wellness",
      "poi_address": "5610 Lake Ridge Pkwy, Grand Prairie, TX 75052, USA",
      "poi_short_description": "A 784-acre waterfront park with a white-sand beach & 2 boat ramps plus volleyball & picnic areas.",
      "poi_long_description": "A 784-acre waterfront park with a white-sand beach & 2 boat ramps plus volleyball & picnic areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc929-1f66-72c9-8868-e2a130a98348.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc929-1f66-72c9-8868-e2a130a98348",
        "storage_key": "property/6767906449167591/019fc929-1f66-72c9-8868-e2a130a98348.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://grandfungp.com/lynn-creek-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7082881544201105444&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lynn-creek-park-at-joe-pool-lake",
      "poi_latitude": "32.635005",
      "poi_longitude": "-97.0304981",
      "poi_miles_from_property": "13.2",
      "poi_walking_minutes": "4 hours 56 mins",
      "poi_biking_minutes": "1 hour 26 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 972-237-4120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d61-769d-a65a-fdf52ce4c1fa",
        "storage_key": "property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9ZotVRWJToYRJPBG3DxzS2I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_aa6b9309-0bc9-4d04-a2b5-74d9381164d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Loyd Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3401 Ragland Rd, Grand Prairie, TX 75052, USA",
      "poi_short_description": "Nature getaway with 220+ lakeside campsites, swimming, hiking & equestrian trails & a boat ramp.",
      "poi_long_description": "Nature getaway with 220+ lakeside campsites, swimming, hiking & equestrian trails & a boat ramp.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc929-1d6a-7206-a0a2-511012e88d45.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc929-1d6a-7206-a0a2-511012e88d45",
        "storage_key": "property/6767906449167591/019fc929-1d6a-7206-a0a2-511012e88d45.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://loydpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4137658278684089738&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "loyd-park",
      "poi_latitude": "32.6131968",
      "poi_longitude": "-97.0694325",
      "poi_miles_from_property": "14.7",
      "poi_walking_minutes": "5 hours 29 mins",
      "poi_biking_minutes": "1 hour 20 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 972-237-4120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc929-48dd-7059-b4f5-3bff4b9c9b14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc929-48dd-7059-b4f5-3bff4b9c9b14",
        "storage_key": "property/6767906449167591/019fc929-48dd-7059-b4f5-3bff4b9c9b14.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQfQAVSaKToYRil3rPkjqazk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "campground"
    },
    {
      "id": "custom_1b90a14d-85cb-4e7b-a275-5276b50bc67c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "River Legacy Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "703 NW Green Oaks Blvd, Arlington, TX 76006, USA",
      "poi_short_description": "River Legacy Park’s sustainably designed nature center offers exhibits, trails & education programs.",
      "poi_long_description": "River Legacy Park’s sustainably designed nature center offers exhibits, trails & education programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5de-44b5-755b-992c-b8c87dcc144e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b5de-44b5-755b-992c-b8c87dcc144e",
        "storage_key": "property/6767906449167591/01a0b5de-44b5-755b-992c-b8c87dcc144e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://riverlegacy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11050832492106717769&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "river-legacy-nature-center",
      "poi_latitude": "32.783464",
      "poi_longitude": "-97.115209",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-860-6752",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d57-7377-98aa-ee7b8900f493.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d57-7377-98aa-ee7b8900f493",
        "storage_key": "property/6767906449167591/019fc925-7d57-7377-98aa-ee7b8900f493.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJWx3Wbct9ToYRSZpdDJpxXJk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_f6043d1a-1ceb-4acb-b2c7-8dfc726023f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Turner Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "600 N Belt Line Rd, Grand Prairie, TX 75050, USA",
      "poi_short_description": "Public 62-acre park featuring sports facilities, a playground, gazebo, pond & walking trail.",
      "poi_long_description": "Public 62-acre park featuring sports facilities, a playground, gazebo, pond & walking trail.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc929-19ea-75b8-a198-09d009602c27.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc929-19ea-75b8-a198-09d009602c27",
        "storage_key": "property/6767906449167591/019fc929-19ea-75b8-a198-09d009602c27.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://turner-park.keeq.io/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13580162027352239507&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "turner-park",
      "poi_latitude": "32.7522781",
      "poi_longitude": "-96.9961224",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 972-237-8399",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d57-7377-98aa-ee7b8900f493.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d57-7377-98aa-ee7b8900f493",
        "storage_key": "property/6767906449167591/019fc925-7d57-7377-98aa-ee7b8900f493.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJRVjH8C2EToYRky2UwGltdrw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_ca1860a7-b3cb-4c02-a733-ee0b0c5d2d44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Mi Familia Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2402 Cardiff St, Grand Prairie, TX 75051, USA",
      "poi_short_description": "Rentable pavilion at a popular lakeside park, with BBQ grills, picnic tables & restrooms.",
      "poi_long_description": "Rentable pavilion at a popular lakeside park, with BBQ grills, picnic tables & restrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5de-47c0-72ff-afed-bc6558c756b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b5de-47c0-72ff-afed-bc6558c756b8",
        "storage_key": "property/6767906449167591/01a0b5de-47c0-72ff-afed-bc6558c756b8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gptx.org/Parks/Mi-Familia-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=9194933698234226885&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mi-familia-park",
      "poi_latitude": "32.7130377",
      "poi_longitude": "-96.9785389",
      "poi_miles_from_property": "9.4",
      "poi_walking_minutes": "3 hours 27 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 972-237-7529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d57-7377-98aa-ee7b8900f493.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d57-7377-98aa-ee7b8900f493",
        "storage_key": "property/6767906449167591/019fc925-7d57-7377-98aa-ee7b8900f493.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJp7GAtY6FToYRxRiFUHv3mn8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1d37da2b-91e8-410f-8cf6-a6a90dbc34ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Visit Grand Prairie",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2170 N Belt Line Rd, Grand Prairie, TX 75050, USA",
      "poi_short_description": "Source of information for local attractions, events, and accommodations, plus maps.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5de-48a7-735e-90d9-42eb79494af9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b5de-48a7-735e-90d9-42eb79494af9",
        "storage_key": "property/6767906449167591/01a0b5de-48a7-735e-90d9-42eb79494af9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.visitgrandprairietx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9672940737073603016&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "visit-grand-prairie",
      "poi_latitude": "32.7725894",
      "poi_longitude": "-96.9940209",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 800-288-8386",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d61-769d-a65a-fdf52ce4c1fa",
        "storage_key": "property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9ykRyBeEToYRyGGt1lkwPYY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_information_center"
    },
    {
      "id": "custom_860e74c0-057c-4822-9817-2466c0e7c11d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "McFalls Pool",
      "poi_type": "Health and Wellness",
      "poi_address": "505 Dickey Rd, Grand Prairie, TX 75051, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5de-4ae7-758b-af23-563d937a8fe3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b5de-4ae7-758b-af23-563d937a8fe3",
        "storage_key": "property/6767906449167591/01a0b5de-4ae7-758b-af23-563d937a8fe3.webp",
        "width": 576,
        "height": 1280
      },
      "poi_business_url": "https://grandfungp.com/aquatics/outdoor-pools/",
      "poi_directions_map_url": "https://maps.google.com/?cid=224572602434558652&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcfalls-pool",
      "poi_latitude": "32.7283992",
      "poi_longitude": "-97.0089844",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 972-237-4170",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d61-769d-a65a-fdf52ce4c1fa",
        "storage_key": "property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP3_GrHWGToYRvJplkpfXHQM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "swimming_pool"
    },
    {
      "id": "custom_12bae214-106c-4709-af13-1c025dc31df4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Dallas Fort Worth International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2400 Aviation Dr, DFW Airport, TX 75261, USA",
      "poi_short_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_long_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc929-35a4-75fc-bdb4-c77d98b9e26f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc929-35a4-75fc-bdb4-c77d98b9e26f",
        "storage_key": "property/6767906449167591/019fc929-35a4-75fc-bdb4-c77d98b9e26f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dfwairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8300766736265584668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dallas-fort-worth-international-airport",
      "poi_latitude": "32.8921983",
      "poi_longitude": "-97.0391232",
      "poi_miles_from_property": "11",
      "poi_walking_minutes": "4 hours 2 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 972-973-3112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc929-48ce-729c-91e8-e607b73b30b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc929-48ce-729c-91e8-e607b73b30b9",
        "storage_key": "property/6767906449167591/019fc929-48ce-729c-91e8-e607b73b30b9.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJpyoiDWYqTIYRHCB9Bl4_MnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_f4406c42-47fb-4896-8378-e43ce635c978",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "CentrePort/DFW Airport Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "14470 Statler Blvd, Fort Worth, TX 76155, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc929-23b1-717d-a71e-0d1c6ff5c27d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc929-23b1-717d-a71e-0d1c6ff5c27d",
        "storage_key": "property/6767906449167591/019fc929-23b1-717d-a71e-0d1c6ff5c27d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.dart.org/guide/transit-and-use/rail/rail-station-detail/centreport-dfw-airport-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=1619245285415004907&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "centreportdfw-airport-station",
      "poi_latitude": "32.8170102",
      "poi_longitude": "-97.0528488",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 214-979-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc929-48c6-758a-bb89-e297242f8b25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc929-48c6-758a-bb89-e297242f8b25",
        "storage_key": "property/6767906449167591/019fc929-48c6-758a-bb89-e297242f8b25.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJN7AqJ-KAToYR6ypjCQK3eBY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_44118366-ed14-47e9-ad03-5bd1c6f4f4d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "DFW Airport North Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Grapevine, TX 76051, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5de-4bbb-72e8-83e8-3f7002a1c63c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b5de-4bbb-72e8-83e8-3f7002a1c63c",
        "storage_key": "property/6767906449167591/01a0b5de-4bbb-72e8-83e8-3f7002a1c63c.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://ridetrinitymetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15538268952942469036&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dfw-airport-north-station",
      "poi_latitude": "32.9339617",
      "poi_longitude": "-97.0541076",
      "poi_miles_from_property": "16.2",
      "poi_walking_minutes": "6 hours 3 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 817-215-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc929-48de-7012-a939-8ce4bfdb1a5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc929-48de-7012-a939-8ce4bfdb1a5e",
        "storage_key": "property/6767906449167591/019fc929-48de-7012-a939-8ce4bfdb1a5e.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJQY7gYQYrTIYRrN-dlEkFo9c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "custom_da8f34db-3534-4198-b4eb-44821a9a521d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "DFW Airport Terminal B",
      "poi_type": "Transportation & Transit",
      "poi_address": "Grapevine, TX 76051, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019ff6c7-3668-706e-877c-3fd045aeab8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c7-3668-706e-877c-3fd045aeab8a",
        "storage_key": "property/6767906449167591/019ff6c7-3668-706e-877c-3fd045aeab8a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://ridetrinitymetro.org/texrail/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17542362866335770885&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dfw-airport-terminal-b",
      "poi_latitude": "32.9062404",
      "poi_longitude": "-97.0412791",
      "poi_miles_from_property": "12",
      "poi_walking_minutes": "4 hours 26 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc929-48de-7012-a939-8ce4bfdb1a5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc929-48de-7012-a939-8ce4bfdb1a5e",
        "storage_key": "property/6767906449167591/019fc929-48de-7012-a939-8ce4bfdb1a5e.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJpectJlwqTIYRBWnyYBX-cvM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "custom_dc1fbd77-4b18-4431-9fc6-fa8dc3f29dc5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Grand Prairie Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "1067 I-30 Frontage Rd, Grand Prairie, TX 75050, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc929-2227-70ae-a838-908aefb0b9c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc929-2227-70ae-a838-908aefb0b9c6",
        "storage_key": "property/6767906449167591/019fc929-2227-70ae-a838-908aefb0b9c6.webp",
        "width": 1280,
        "height": 740
      },
      "poi_business_url": "https://www.gptx.org/Departments/Transportation-and-Mobility-Services/Park-and-Ride",
      "poi_directions_map_url": "https://maps.google.com/?cid=17407978255013738281&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grand-prairie-park-and-ride",
      "poi_latitude": "32.7576575",
      "poi_longitude": "-96.9878723",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-237-8139",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc929-48c6-758a-bb89-e297242f8b25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc929-48c6-758a-bb89-e297242f8b25",
        "storage_key": "property/6767906449167591/019fc929-48c6-758a-bb89-e297242f8b25.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJX-kM_jaEToYRKXfR0_2PlfE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_2f078eff-70dd-4263-90ce-ce1c9fe4829e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Lockheed Martin MFC Grand Prairie",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1601 W Marshall Dr, Grand Prairie, TX 75051, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3265150620703052233&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lockheed-martin-mfc-grand-prairie",
      "poi_latitude": "32.7194095",
      "poi_longitude": "-97.0361893",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d61-769d-a65a-fdf52ce4c1fa",
        "storage_key": "property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_bKe6qCHToYRydEmpTAlUC0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_ee18a341-c462-44f9-bbdd-377d903c2dc9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Airbus Helicopters, Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2701 N Forum Dr, Grand Prairie, TX 75052, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5de-4cef-71ea-b8ed-888f976c9d0d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b5de-4cef-71ea-b8ed-888f976c9d0d",
        "storage_key": "property/6767906449167591/01a0b5de-4cef-71ea-b8ed-888f976c9d0d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.airbus.com/us/en/helicopters.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=7819922541125241749&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "airbus-helicopters-inc",
      "poi_latitude": "32.7009981",
      "poi_longitude": "-97.0526688",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 972-641-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d61-769d-a65a-fdf52ce4c1fa",
        "storage_key": "property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4-oBatWHToYRlQvXkh7yhWw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_ca4b75c5-cfa2-48ca-b9dc-ff6e7d9ae9e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Flex-N-Gate Texas",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2150 Bardin Rd, Grand Prairie, TX 75052, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019ff6c7-3f63-75cb-9fc6-62f101e8870e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c7-3f63-75cb-9fc6-62f101e8870e",
        "storage_key": "property/6767906449167591/019ff6c7-3f63-75cb-9fc6-62f101e8870e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.flex-n-gate.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15499426750143241255&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flex-n-gate-texas",
      "poi_latitude": "32.6712107",
      "poi_longitude": "-97.0328184",
      "poi_miles_from_property": "10.1",
      "poi_walking_minutes": "3 hours 46 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 817-652-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d61-769d-a65a-fdf52ce4c1fa",
        "storage_key": "property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI59MEQqHToYRJ5x5gIIGGdc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_8e26c4f7-86bb-4c6c-a4b1-f0137f978d4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Poly-America",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2000 W Marshall Dr, Grand Prairie, TX 75051, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019ff6c7-3dea-74dd-bb50-9b1339f71423.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c7-3dea-74dd-bb50-9b1339f71423",
        "storage_key": "property/6767906449167591/019ff6c7-3dea-74dd-bb50-9b1339f71423.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.poly-america.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=156461656035098014&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "poly-america",
      "poi_latitude": "32.7214802",
      "poi_longitude": "-97.0259077",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 972-337-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d61-769d-a65a-fdf52ce4c1fa",
        "storage_key": "property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgzFD6D6GToYRnv3wFAzdKwI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_4e3880e7-23da-430c-975d-9e8588a0ce00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "Siemens",
      "poi_type": "Major Employers & Offices",
      "poi_address": "501 Fountain Pkwy, Grand Prairie, TX 75050, USA",
      "poi_short_description": "Global firm specializing in digitalization, electrification, and automation for the process and manufacturing industries.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5de-50e8-7189-82f3-55d887da9d38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b5de-50e8-7189-82f3-55d887da9d38",
        "storage_key": "property/6767906449167591/01a0b5de-50e8-7189-82f3-55d887da9d38.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://usa.siemens.com/usa",
      "poi_directions_map_url": "https://maps.google.com/?cid=2149013589755346640&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "siemens",
      "poi_latitude": "32.7780314",
      "poi_longitude": "-97.0583181",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 866-663-7324",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d61-769d-a65a-fdf52ce4c1fa",
        "storage_key": "property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6bbBaCWHToYR0L7aUnnU0h0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_945dba00-d60f-420c-a62c-a1b831f9452c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "K&N",
      "poi_type": "Major Employers & Offices",
      "poi_address": "741 Refuge Wy, Grand Prairie, TX 75050, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b5de-50db-76f2-a49a-4b38ecc2de88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b5de-50db-76f2-a49a-4b38ecc2de88",
        "storage_key": "property/6767906449167591/01a0b5de-50db-76f2-a49a-4b38ecc2de88.webp",
        "width": 1000,
        "height": 563
      },
      "poi_business_url": "https://www.knfilters.com/air-filters?gclid=Cj0KCQjwhb36BRCfARIsAKcXh6Gz7Wb07Exf58sIZUfQOSHw5GBwoanmhNSWJd0WnTd1rRCo9H1v6N8aAu5XEALw_wcB",
      "poi_directions_map_url": "https://maps.google.com/?cid=10697569210596580454&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kn",
      "poi_latitude": "32.7667992",
      "poi_longitude": "-96.9995965",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 214-861-6901",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d61-769d-a65a-fdf52ce4c1fa",
        "storage_key": "property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ331lp7GFToYRZtzD1YRmdZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "storage"
    },
    {
      "id": "custom_6379d6b2-098d-4f5f-a40d-b5a14d48f26d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "General Motors",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2525 E Abram St, Arlington, TX 76010, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc929-3164-7348-b0d4-eb02b75b3510.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc929-3164-7348-b0d4-eb02b75b3510",
        "storage_key": "property/6767906449167591/019fc929-3164-7348-b0d4-eb02b75b3510.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://media.gm.com/media/us/en/gm/home.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=6761053318444601885&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "general-motors",
      "poi_latitude": "32.7367142",
      "poi_longitude": "-97.0659121",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 800-462-8782",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d61-769d-a65a-fdf52ce4c1fa",
        "storage_key": "property/6767906449167591/019fc925-7d61-769d-a65a-fdf52ce4c1fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLXe5eKSHToYRHdJd6SsW1F0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b8bce9d1-32ed-4c7b-bcd9-6d534766b468",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "The University of Texas at Arlington",
      "poi_type": "Education",
      "poi_address": "701 S Nedderman Dr, Arlington, TX 76019, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-4fa3-7310-bd75-8494a391fed7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc925-4fa3-7310-bd75-8494a391fed7",
        "storage_key": "property/6767906449167591/019fc925-4fa3-7310-bd75-8494a391fed7.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://www.uta.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7808325519304865642&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-university-of-texas-at-arlington",
      "poi_latitude": "32.7292117",
      "poi_longitude": "-97.1151971",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 817-272-2011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d61-769d-a65b-02cbbc9220ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d61-769d-a65b-02cbbc9220ef",
        "storage_key": "property/6767906449167591/019fc925-7d61-769d-a65b-02cbbc9220ef.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTVbJq219ToYRarfIhLC-XGw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_b0f94cef-f6d1-4754-bc23-c0b6a7454358",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "poi_name": "AT&T Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1 AT&T Way, Arlington, TX 76011, USA",
      "poi_short_description": "Home stadium of the Dallas Cowboys football team & host to big-name concert acts, events & tours.",
      "poi_long_description": "Home stadium of the Dallas Cowboys football team & host to big-name concert acts, events & tours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-5f97-7050-867b-a717b1856929.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc925-5f97-7050-867b-a717b1856929",
        "storage_key": "property/6767906449167591/019fc925-5f97-7050-867b-a717b1856929.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://attstadium.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7862828551339941368&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "att-stadium",
      "poi_latitude": "32.7480281",
      "poi_longitude": "-97.0928124",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 817-892-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/019fc925-7d3b-76de-b4aa-a60e0dc8335b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc925-7d3b-76de-b4aa-a60e0dc8335b",
        "storage_key": "property/6767906449167591/019fc925-7d3b-76de-b4aa-a60e0dc8335b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ0eIyIZ9ToYR-J1qjOhgHm0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    }
  ],
  "office_hours": [
    {
      "id": "ec_c42579ba61f23fa8801c869c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_98f670efa84d8e7f005fa6af",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_682665c21156f19d86c49f59",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_6995c83868211f0e8a3882b6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_0818283c96466442e7ce77cb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_1e72d3583c30135b4c4b92f7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_1856f485-8c59-47a4-8095-422291fef930",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "rating": "5.0",
      "name": "IVIE OSUNDE",
      "text": "The Clairborne apartments have been the best neighborhood I’ve ever experienced in my life. They exceeded expectations concerning maintenance no rodents roaches no white appliances. Gym is always spotless the coffee machine helps me throughout my work at home days. This experience is definitely giving me Garden of Eden vibes. Try it for yourself you won’t be disappointed. God as my witness! They give grace until the 5th of the month to make payments just make sure to not take advantage of that and be a responsible adult and they will continue to do their part to upkeep your unit as well as the complex. Very beautiful scenery all my packages arrive safely nobody steals here it’s giving LUXURY YET AFFORDABLE. Here to stay until my future husband comes to rescue me from the single life. In due time! Thanks again Clairborne apartments for putting your residents first. Garden tubs in the master bathroom spacious rooms  high ceilings spacious patios in the 2 bedroom units. Very grateful!",
      "date": "2026-01-21",
      "title": ""
    },
    {
      "id": "custom_e77913f1-7739-491c-ae1b-9c0392426683",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "rating": "5.0",
      "name": "Marielle",
      "text": "I lived there for three years and really loved and appreciated the staff. Collette was excellent at her job and very kind. The maintenance workers were always friendly and there to fix any apartment issues.  Especially Jose and Alberto (I think his name was). The pool was beautiful. The highway can cause a lot of noise pollution, but if you live towards the back side of the complex, it is not bad at all.",
      "date": "2025-01-06",
      "title": ""
    },
    {
      "id": "custom_956d93f3-6bfe-4f46-9fbe-f2d8b385a550",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "rating": "5.0",
      "name": "Erik Bounds",
      "text": "We have been residents here for a little over 2 years .  We love the Leasing office staff , and very pleased  with the New upper management Supervisor Eduardo.   He has been the difference , and things are getting done.  Highly recommend this complex to anyone looking for a good place to live.",
      "date": "2026-03-12",
      "title": ""
    },
    {
      "id": "custom_9ba1dc62-ba31-415c-a25c-1fce80f98b10",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "rating": "5.0",
      "name": "Wesley",
      "text": "I’ve lived at The Clairborne for about 5 months and have had no issues. The office staff is very personable, kind and helpful. The maintenance team takes care of any issue in a timely manner. The community is very quiet and safe. If you value any of the things I mentioned then I recommend you stop wasting your time with other complex’s and visit The Clairborne.",
      "date": "2026-10-16",
      "title": ""
    },
    {
      "id": "custom_49917324-eae3-4b5a-8910-d8f69fc82843",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "rating": "4.0",
      "name": "Saadu Bukola",
      "text": "Customer service is awesome.",
      "date": "2026-09-30",
      "title": ""
    },
    {
      "id": "custom_86825805-cdc3-4403-873a-6fe59cb93090",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "rating": "5.0",
      "name": "Roberto Martinez",
      "text": "Excellent\n",
      "date": "2026-10-30",
      "title": ""
    },
    {
      "id": "custom_fdbdf848-108b-4039-a49f-89ee059f77c2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "rating": "5.0",
      "name": "Somaia Ramadan",
      "text": "We had the pleasure of working with Colette,  and we couldn't be happier with our experience. Colette was very professional and patient throughout the entire leasing process. She answered all of our questions and provided clear explanations every step of the way, I highly recommend working with her.\n\nI will update my review once we get our keys.\n\nBeen here for almost a year. I absolutely love living in this apartment and have had a great experience overall. Maintenance is always quick, helpful, and very friendly, which I truly appreciate. The only concern I have is that the appliances are quite old, including the stove, dishwasher, and refrigerator. Updating the appliances would greatly improve an already wonderful living experience. I hope management will consider upgrading them in the near future.",
      "date": "2025-12-28",
      "title": ""
    },
    {
      "id": "custom_e42f50a4-8587-432a-b62f-01997265aa53",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "rating": "5.0",
      "name": "Hasan Zafar",
      "text": "Almost a year here and I have loved how well managed and resident focused this community is. Management is great, apartments are spacious, community is green, and the hot tub/coffee bar make you want to go to the clubhouse. Gym can be improved but overall fantastic experience so far.",
      "date": "2025-12-26",
      "title": ""
    },
    {
      "id": "custom_41b11eb9-8c49-4885-9ed9-a81cff939cde",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "rating": "5.0",
      "name": "Walter McDonald",
      "text": "I've lived here for 6yrs. Four years by myself and 2 years with my daughter and its been a good experience. Maintenance and the ground keepers, please keep up the good work. The office crew, changed a little but keep up the good work. Collette, we go WAY back lol. Thanks, for everything!!!",
      "date": "2025-10-29",
      "title": ""
    },
    {
      "id": "custom_f2c0b22b-da9f-4798-a590-d86bbcb83fa5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "rating": "5",
      "name": "Gerardo Orozco",
      "text": "Great property. Friendly staff. Service is quick and effective. Caleb is awesome!",
      "date": "2025-10-24",
      "title": "false"
    },
    {
      "id": "custom_db384551-d4a4-4161-b1fa-d0830031d4fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "rating": "5",
      "name": "Jennifer Lynn",
      "text": "Fantastic place to live. We’ve lived here about 3 years and it’s been amazing. The only reason we’re leaving is because we’re moving states. Everything has been wonderful, the staff is amazing. Everyone from the front office to maintenance are all wonderful, they take care of issues quickly and efficiently.\n",
      "date": "2025-10-23",
      "title": "false"
    },
    {
      "id": "custom_68e65dea-0521-4119-a920-5f06dd2ceb53",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "rating": "5",
      "name": "Jay Martin",
      "text": "Very pleasant living experience. I lived here for about 4 years and never had an issue. Timely maintenance beautiful apartment home, and quiet neighborhood. Office staff was great including the assistant manager. She does work with you and is very understanding. Collete in the front office is very nice . Always willing to lend a helping hand. Definitely recommend this place.",
      "date": "2025-10-20",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_80bdaa3f-186c-47d9-9714-6e87bda2fcd3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167591/01a0b62f-759b-72c8-9413-bd8573bdb11b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b62f-759b-72c8-9413-bd8573bdb11b",
        "storage_key": "property/6767906449167591/01a0b62f-759b-72c8-9413-bd8573bdb11b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Clairborne - Waverly",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=bY7czFfXqgz"
    }
  ],
  "faqs": [
    {
      "id": "custom_0a5aefc7-2e52-4121-a7ae-9aede6fc93d6",
      "question": "What are the qualifications for occupancy?",
      "answer": "Check our occupancy qualifications <a href=\"https://www.pricebrotherskc.com/ResidentialRentalQualifications/\">here</a>. We encourage everyone to apply, and hope to have you as a part of our community!",
      "category": "Rental Qualifications",
      "source": "custom"
    },
    {
      "id": "custom_de270551-f95b-410d-839a-2e3e518e4d57",
      "question": "What is the application fee and is it refundable?",
      "answer": "Application fees are due for each person 18 and older occupying the apartment. All application fees are nonrefundable.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_ccedc86c-a6a9-48b4-b3a4-815e4986e98c",
      "question": "How do I apply?",
      "answer": "Click on the <a href=\"/apply-now\">Apply Now</a> button under the <a href=\"/floor-plans\">Floor Plans</a> tab of our community website.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_46af7403-be86-4871-ba17-06706ebb17b4",
      "question": "Are there different lease term options available?",
      "answer": "Yes, we offer various lease term options. Please <a href=\"/contact-us\">contact our office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_6be8b886-1b74-4a4e-9f2a-32d483591a1b",
      "question": "Do I need an appointment to take a tour?",
      "answer": "No appointment is necessary to tour our community during business hours; however, it is always appreciated if you call ahead to make sure we are available to provide adequate time for you to tour and ask questions. It is recommended to arrive no later than one half hour prior to closing if you would like to tour the community. Everyone over 18 years of age must have a valid photo ID to tour. Valid forms of identification are decided by Price Brothers Management Company and may include items such as: US Driver’s License, US State Photo ID, US Military Photo ID, US Visa with Photo ID upon it, US Citizenship and Immigration Services Photo ID, Passport.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_3c15fd8f-8a49-4a30-bde2-e4318a6478d4",
      "question": "Do you allow pets?",
      "answer": "Our community is happy to accept cats and dogs. Please refer to our pet section on the <a href=\"/pet-policy\">Pet Policy</a> page.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_ee869de1-787b-47fe-9240-ed91858f1846",
      "question": "What is a holding deposit or earnest money?",
      "answer": "A \"holding\" deposit or \"earnest money\" is another word for \"security\" deposit. Please <a href=\"/contact-us\">contact our leasing office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_20365b42-fd54-4e55-8a78-2d7a51972d3c",
      "question": "Why does your pricing include ranges?",
      "answer": "The prices will range on each floor plan depending on finishes, views, and other features inside the apartment home.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_457ff12b-5ae0-43f1-af91-19eaa512bd43",
      "question": "How can I refer a friend?",
      "answer": "If you love living here and want to refer a friend, please let our office know! We offer resident referral programs throughout the year and would love for your friends and family to join our community.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_a08b5985-0575-43da-b056-73567209439b",
      "question": "What utilities am I responsible to pay?",
      "answer": "Our residents are responsible to pay for water, trash, and electric.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_da6bdfdf-f77b-4251-bbb6-b9e3a5471c6c",
      "question": "Do you require renters insurance?",
      "answer": "All residents are required to maintain a minimum of $100,000 in liability coverage as part of their lease agreement. For more details on coverage requirements and available options, please <a href=\"/contact-us\">contact our leasing office</a>.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_3acd7305-eba1-4cf2-9a2c-4b8b3c995ff5",
      "question": "How can I pay my rent?",
      "answer": "You can pay rent by accessing your <a href=\"/resident-access\">resident online account</a>. This allows you to use a bank account or credit card to make payments.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_f954a0eb-ee32-4da6-a354-19dd945d816a",
      "question": "Do you offer flexible rent payment options?",
      "answer": "Yes! We’ve partnered with Flex to make paying rent easier for our residents. Flex allows you to split your rent into smaller, more manageable payments throughout the month, giving you added financial flexibility. For more details or to sign up, <a href=\"/contact-us\">contact our leasing office</a> today!",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_7c076f4a-90db-4acd-9c0b-4ceccded82de",
      "question": "Do you offer covered parking?",
      "answer": "Yes, we offer carports for rent. Please <a href=\"/contact-us\">contact the office</a> for our most current parking availability.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_55f017e4-d091-4847-b23a-1a9dea7b4ec6",
      "question": "Do you host events at your property?",
      "answer": "Yes, we host events throughout the year with various activities to encourage community camaraderie.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_7b27ced2-16be-4344-a425-87fe399783f1",
      "question": "Do you accept packages on behalf of the residents?",
      "answer": "No, we do not offer this service at this time.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_0bf1a336-1be8-408f-80e9-1d46edfa05f8",
      "question": "If something needs to be repaired in my apartment, how do I report it?",
      "answer": "You may call the office or submit work orders online by accessing your <a href=\"/resident-access\">resident account</a>. All emergency repairs should be reported by <a href=\"/contact-us\">contacting the office</a>. If the emergency is being reported after business hours, please follow the prompts to be connected to the answering service.",
      "category": "Maintenance",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0c9ac-4952-73fe-aa37-68877559283f",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "The Clairborne Apartment Homes Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591"
    },
    {
      "lead_collector_id": "01a0c9ac-49e0-742f-b39e-392f0ad84a9b",
      "lead_source": "LANDING_PAGE",
      "name": "The Clairborne Apartment Homes Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "page_item_url": "apartments-with-pool-grand-prairie",
      "search_query": "apartments with pool in Grand Prairie",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Grand Prairie",
      "h2_subtitle": "Discover apartments with a pool in Grand Prairie at The Clairborne. Enjoy easy living with great amenities in a desirable location.",
      "page_copy": "Looking for apartments with a pool in Grand Prairie? The Clairborne Apartment Homes offer the perfect blend of luxury and convenience. Situated near Highway 360, our community provides a refreshing swimming pool that promises relaxation and enjoyment. Join our friendly and welcoming community in North Arlington, and indulge in the wide range of amenities designed to enhance your lifestyle. \n\nBeyond the pool, residents can enjoy high-speed internet access and beautifully designed interiors featuring crown molding and a travertine fireplace. Whether you choose a one-, two-, or three-bedroom apartment, you'll love living in our gated community. Explore our amenities and experience connected Grand Prairie living at its best. Schedule a tour today and see our exceptional apartments and pool for yourself.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an apartment complex courtyard with a large swimming pool, lounge chairs, umbrellas, and a gazebo.",
        "public_id": "019fc926-2ff8-7658-be86-0fcbc17a81ed",
        "storage_key": "property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Grand Prairie",
      "seo_description": "Enjoy comfortable living with a variety of amenities in a prime location near Highway 360.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "page_item_url": "air-conditioned-apartments-north-arlington",
      "search_query": "air conditioned apartments in North Arlington",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in North Arlington",
      "h2_subtitle": "Stay comfortable year-round in air-conditioned apartments at The Clairborne in North Arlington. Discover the perfect home today.",
      "page_copy": "Discover air conditioned apartments in North Arlington at The Clairborne Apartment Homes, where comfort meets convenience. Nestled close to Highway 360, our community ensures a cool, refreshing retreat from the Texas heat with air conditioning available in all units. Our spacious one-, two-, and three-bedroom homes are designed to provide maximum comfort and style for all residents.\n\nEnhance your living experience with our desirable amenities, including a travertine fireplace, crown molding, and high-speed internet access. The Clairborne is a gated community offering both security and luxury. Enjoy modern living in North Arlington and explore all that The Clairborne has to offer by scheduling a tour today. Immerse yourself in a lifestyle where comfort is paramount.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an apartment complex courtyard with a large swimming pool, lounge chairs, umbrellas, and a gazebo.",
        "public_id": "019fc926-2ff8-7658-be86-0fcbc17a81ed",
        "storage_key": "property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in North Arlington",
      "seo_description": "Find air-conditioned apartments in North Arlington at The Clairborne. Enjoy comfort and style near Highway 360. Tour our community today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "page_item_url": "in-unit-laundry-grand-prairie-tarrant-county",
      "search_query": "in unit laundry Grand Prairie Tarrant County",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry in Grand Prairie, Tarrant County",
      "h2_subtitle": "Enjoy the convenience of in-unit laundry in Grand Prairie at The Clairborne. Experience luxurious living in Tarrant County.",
      "page_copy": "Experience the luxury of in-unit laundry in Grand Prairie, Tarrant County, at The Clairborne Apartment Homes. Our well-appointed community is conveniently situated near Highway 360, providing quick access for your daily routine. Each home is designed for practical living, with in-unit laundry facilities ensuring you save time and enjoy the comfort of doing laundry at home.\n\nThe Clairborne also offers numerous amenities to enhance your lifestyle. Relax by the pool, or take advantage of high-speed internet access and beautifully appointed interiors. Our one-, two-, and three-bedroom apartments include features like crown molding and a travertine fireplace, making every day feel like a retreat. Discover the convenience of in-unit laundry along with our other modern amenities by scheduling a tour today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an apartment complex courtyard with a large swimming pool, lounge chairs, umbrellas, and a gazebo.",
        "public_id": "019fc926-2ff8-7658-be86-0fcbc17a81ed",
        "storage_key": "property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Grand Prairie, Tarrant County",
      "seo_description": "Find in-unit laundry in Grand Prairie at The Clairborne. Convenient, modern living in Tarrant County. Schedule a tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "page_item_url": "gated-community-apartments-grand-prairie-tx",
      "search_query": "gated community apartments Grand Prairie TX",
      "category": "Amenity",
      "h1_title": "Gated Community Apartments in Grand Prairie, TX",
      "h2_subtitle": "Discover gated community apartments in Grand Prairie, TX at The Clairborne. Enjoy gated access in a convenient location.",
      "page_copy": "Looking for gated community apartments in Grand Prairie, TX? Welcome to The Clairborne Apartment Homes, where privacy, security, and comfort blend seamlessly. Located near Highway 360 in Tarrant County, our community features gated access for residents. Enjoy the benefits of a gated community while taking in everything Grand Prairie has to offer.\n\nOur one-, two-, and three-bedroom apartments feature high-speed internet access, crown molding, and a charming travertine fireplace. The Clairborne’s prime location in North Arlington ensures that residents enjoy the conveniences of city living while relishing the serene environment of a gated community. Schedule a tour today to experience firsthand our community’s vibrant atmosphere and appealing amenities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an apartment complex courtyard with a large swimming pool, lounge chairs, umbrellas, and a gazebo.",
        "public_id": "019fc926-2ff8-7658-be86-0fcbc17a81ed",
        "storage_key": "property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gated Community Apartments, Grand Prairie TX",
      "seo_description": "Explore gated community apartments at The Clairborne in Grand Prairie, TX. Enjoy gated access and a variety of amenities near Highway 360.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "page_item_url": "apartments-with-fitness-center-highway-360",
      "search_query": "apartments with fitness center near Highway 360",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center Near Highway 360",
      "h2_subtitle": "Stay active at The Clairborne's fitness center near Highway 360. Discover our spacious apartments today.",
      "page_copy": "For those seeking apartments with a fitness center near Highway 360, The Clairborne Apartment Homes provides the perfect blend of convenience and wellness. Our community, located in the vibrant city of Grand Prairie, TX, offers residents the benefit of a well-equipped fitness center just steps from their door. Whether you're a fitness enthusiast or just looking to maintain a healthy lifestyle, The Clairborne makes it easy.\n\nBeyond our fitness center, The Clairborne boasts a wide range of amenities, including a travertine fireplace, crown molding, and high-speed internet access in our spacious one-, two-, and three-bedroom homes. Positioned near Highway 360, residents have quick access to everything the North Arlington area has to offer while enjoying a serene community setting. Schedule your tour today and elevate your living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an apartment complex courtyard with a large swimming pool, lounge chairs, umbrellas, and a gazebo.",
        "public_id": "019fc926-2ff8-7658-be86-0fcbc17a81ed",
        "storage_key": "property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center Near Highway 360",
      "seo_description": "Discover apartments with a fitness center near Highway 360 at The Clairborne. Enjoy modern amenities in Grand Prairie, TX. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-grand-prairie-tx",
      "search_query": "one bedroom apartments in Grand Prairie TX",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Grand Prairie, TX",
      "h2_subtitle": "Find spacious one bedroom apartments in Grand Prairie, TX at The Clairborne. Enjoy upscale amenities and a convenient location.",
      "page_copy": "Searching for one bedroom apartments in Grand Prairie, TX? The Clairborne Apartment Homes provides the perfect living space tailored to your lifestyle. Our one-bedroom apartments are designed with modern elegance, offering features like crown molding, a charming travertine fireplace, and a fully equipped kitchen. Situated near Highway 360, our location offers easy access to everything Grand Prairie has to offer.\n\nThe Clairborne's community amenities enhance your everyday living, with high-speed internet access, a swimming pool, and a gated environment for added security. Whether you're new to the area or seeking a fresh start, our one-bedroom options provide both comfort and convenience right in Tarrant County. Schedule a tour today to see why The Clairborne is the ideal place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an apartment complex courtyard with a large swimming pool, lounge chairs, umbrellas, and a gazebo.",
        "public_id": "019fc926-2ff8-7658-be86-0fcbc17a81ed",
        "storage_key": "property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Grand Prairie, TX",
      "seo_description": "Explore one bedroom apartments at The Clairborne in Grand Prairie, TX. Enjoy modern amenities and a prime location near Highway 360.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-north-arlington",
      "search_query": "two bedroom apartments North Arlington",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in North Arlington",
      "h2_subtitle": "Discover spacious two bedroom apartments in North Arlington at The Clairborne. Experience modern living and convenience.",
      "page_copy": "Discover the ideal two bedroom apartments in North Arlington at The Clairborne Apartment Homes. Offering a perfect blend of style and practicality, our two-bedroom units boast features like a fully equipped kitchen, crown molding, and a welcoming travertine fireplace. Nestled close to Highway 360, our community provides easy access to the lively environment of Grand Prairie, TX while maintaining a serene residential vibe.\n\nThe Clairborne offers a range of desirable amenities, including high-speed internet access and gated community entry. Whether you're looking for a home office, extra space, or a more spacious living arrangement, our two-bedroom options offer comfort and convenience. Schedule a tour today and see what The Clairborne has to offer in North Arlington.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an apartment complex courtyard with a large swimming pool, lounge chairs, umbrellas, and a gazebo.",
        "public_id": "019fc926-2ff8-7658-be86-0fcbc17a81ed",
        "storage_key": "property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments North Arlington",
      "seo_description": "Explore two bedroom apartments in North Arlington at The Clairborne. Enjoy upscale living near Highway 360 with stylish amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-tarrant-county",
      "search_query": "three bedroom apartments Tarrant County",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Tarrant County",
      "h2_subtitle": "Explore spacious three bedroom apartments in Tarrant County at The Clairborne. Enjoy comfort and modern amenities.",
      "page_copy": "If you're in search of three bedroom apartments in Tarrant County, The Clairborne Apartment Homes offers a perfect fit. Our expansive three-bedroom units provide ample space and feature upscale touches like crown molding and a cozy travertine fireplace. Conveniently located near Highway 360, The Clairborne provides easy access to the cultural and recreational amenities of both Grand Prairie and the greater North Arlington area.\n\nResidents at The Clairborne enjoy a wide range of community amenities, including high-speed internet access and gated community entry. Whether you're looking for extra room or simply desire more space, our three-bedroom apartments offer comfort and convenience. Contact us today to schedule a tour and experience the best of Tarrant County living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an apartment complex courtyard with a large swimming pool, lounge chairs, umbrellas, and a gazebo.",
        "public_id": "019fc926-2ff8-7658-be86-0fcbc17a81ed",
        "storage_key": "property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Tarrant County",
      "seo_description": "Discover three bedroom apartments in Tarrant County at The Clairborne. Enjoy spacious living and modern amenities near Highway 360.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "page_item_url": "apartments-near-eisenhower-elementary-grand-prairie",
      "search_query": "apartments near eisenhower elementary school grand prairie",
      "category": "School",
      "h1_title": "Apartments Near Eisenhower Elementary, Grand Prairie",
      "h2_subtitle": "Discover comfortable apartments near Eisenhower Elementary School in Grand Prairie. The Clairborne offers convenience and modern amenities.",
      "page_copy": "Are you looking for apartments near Eisenhower Elementary School in Grand Prairie? The Clairborne Apartment Homes offers a convenient location near local schools and everyday destinations. Located just a short drive from the school, our community provides easy access to educational and recreational facilities while offering spacious living in our one-, two-, and three-bedroom layouts.\n\nLiving at The Clairborne, residents enjoy high-speed internet access, a fully equipped kitchen, and modern community amenities, all within a gated community. Our convenient location near Highway 360 means easy access to destinations throughout the area. Experience the best of Grand Prairie living by scheduling a tour at The Clairborne today and explore your next home near Eisenhower Elementary.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an apartment complex courtyard with a large swimming pool, lounge chairs, umbrellas, and a gazebo.",
        "public_id": "019fc926-2ff8-7658-be86-0fcbc17a81ed",
        "storage_key": "property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Eisenhower Elementary Grand Prairie",
      "seo_description": "Find apartments near Eisenhower Elementary School at The Clairborne, Grand Prairie. Enjoy convenience, spacious living, and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "page_item_url": "apartments-close-to-hector-p-garcia-elementary",
      "search_query": "apartments close to hector p garcia elementary school",
      "category": "School",
      "h1_title": "Apartments Close to Hector P. Garcia Elementary",
      "h2_subtitle": "Find spacious apartments close to Hector P. Garcia Elementary School at The Clairborne. Enjoy an ideal location and modern amenities.",
      "page_copy": "Looking for apartments close to Hector P. Garcia Elementary School? The Clairborne Apartment Homes offers a blend of location and comfort. Situated just a convenient drive from the school, The Clairborne provides convenient access to local schools and neighborhood amenities.\n\nOur community features spacious one-, two-, and three-bedroom apartments equipped with modern conveniences like high-speed internet and a fully equipped kitchen. Residents also enjoy community features such as gated access, along with interior details like a travertine fireplace and crown molding. Positioned near Highway 360 in North Arlington, these apartments offer easy access to a variety of local destinations, making The Clairborne a convenient option near Hector P. Garcia Elementary.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an apartment complex courtyard with a large swimming pool, lounge chairs, umbrellas, and a gazebo.",
        "public_id": "019fc926-2ff8-7658-be86-0fcbc17a81ed",
        "storage_key": "property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Hector P. Garcia Elementary",
      "seo_description": "Discover The Clairborne Apartments near Hector P. Garcia Elementary. Enjoy spacious, modern living and ideal location in Grand Prairie.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "page_item_url": "north-arlington-apartments-near-crosswinds-high-school",
      "search_query": "north arlington apartments near crosswinds high school",
      "category": "School",
      "h1_title": "North Arlington Apartments Near Crosswinds High",
      "h2_subtitle": "Live close to Crosswinds High School in North Arlington. Discover spacious apartments offering modern amenities at The Clairborne.",
      "page_copy": "For those seeking North Arlington apartments near Crosswinds High School, The Clairborne Apartment Homes is a standout choice. Ideally located, our community offers a convenient commute to Crosswinds High, while providing easy access to all that North Arlington has to offer.\n\nAt The Clairborne, you will find a variety of one-, two-, and three-bedroom layouts, each designed with comfort and modern living in mind. Residents can enjoy high-speed internet access, a well-equipped kitchen, and community features such as a gated entrance and a cozy fireplace. Situated near Highway 360, our location not only provides proximity to Crosswinds High but also offers convenient access to shopping and dining options in the area. Experience the convenience of living at The Clairborne by scheduling a visit today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an apartment complex courtyard with a large swimming pool, lounge chairs, umbrellas, and a gazebo.",
        "public_id": "019fc926-2ff8-7658-be86-0fcbc17a81ed",
        "storage_key": "property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "North Arlington Apartments Near Crosswinds High",
      "seo_description": "Explore The Clairborne Apartments near Crosswinds High in North Arlington, offering comfort, convenience, and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "page_item_url": "apartments-near-grand-prairie-high-school-tx",
      "search_query": "apartments near grand prairie high school tx",
      "category": "School",
      "h1_title": "Apartments Near Grand Prairie High School, TX",
      "h2_subtitle": "Explore comfortable living in Grand Prairie with The Clairborne. Our apartments are conveniently located near Grand Prairie High School, TX.",
      "page_copy": "Searching for apartments near Grand Prairie High School, TX? Look no further than The Clairborne Apartment Homes, conveniently located near local educational facilities and everyday destinations. Situated in Grand Prairie, our community provides easy access to nearby schools, making daily commutes more convenient.\n\nThe Clairborne features spacious one-, two-, and three-bedroom apartments with modern amenities such as high-speed internet, a fully equipped kitchen, and community access to a beautifully crafted travertine fireplace. Located near Highway 360, our residents enjoy a seamless blend of convenience and comfort, with various shopping and dining options nearby. Visit us today and discover what The Clairborne has to offer near Grand Prairie High School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an apartment complex courtyard with a large swimming pool, lounge chairs, umbrellas, and a gazebo.",
        "public_id": "019fc926-2ff8-7658-be86-0fcbc17a81ed",
        "storage_key": "property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Grand Prairie High School, TX",
      "seo_description": "Discover The Clairborne, located near Grand Prairie High School, TX. Enjoy spacious living with modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "page_item_url": "apartments-close-to-truman-middle-school-tarrant-county",
      "search_query": "apartments close to truman middle school tarrant county",
      "category": "School",
      "h1_title": "Apartments Close to Truman Middle School",
      "h2_subtitle": "Find ideal living at The Clairborne, just minutes from Truman Middle School in Tarrant County. Enjoy convenient access and community amenities.",
      "page_copy": "The Clairborne Apartment Homes offers apartments near Truman Middle School in Tarrant County, with convenient access to nearby schools, shopping, dining, and other local destinations in North Arlington.\n\nChoose from one-, two-, and three-bedroom apartments featuring modern conveniences, including high-speed internet and fully equipped kitchens. The gated community also offers amenities such as a fireplace and crown molding. Located near Highway 360, The Clairborne provides convenient access to Truman Middle School and surrounding destinations in the North Arlington area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an apartment complex courtyard with a large swimming pool, lounge chairs, umbrellas, and a gazebo.",
        "public_id": "019fc926-2ff8-7658-be86-0fcbc17a81ed",
        "storage_key": "property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Truman Middle School, Tarrant",
      "seo_description": "Live near Truman Middle School in Tarrant County at The Clairborne. Enjoy spacious apartments and modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "page_item_url": "apartments-near-rayburn-elementary-steam-academy-75050",
      "search_query": "apartments near rayburn elementary steam academy 75050",
      "category": "School",
      "h1_title": "Apartments Near Rayburn Elementary STEAM Academy",
      "h2_subtitle": "Discover living near Rayburn Elementary STEAM Academy in Grand Prairie. The Clairborne offers convenient access in the 75050 area.",
      "page_copy": "Looking for apartments near Rayburn Elementary STEAM Academy? The Clairborne Apartment Homes offers a convenient location in Grand Prairie, 75050, with easy access to the academy and nearby destinations.\n\nThe Clairborne offers a blend of comfort and style with spacious one-, two-, and three-bedroom options. Residents enjoy high-speed internet, a well-appointed kitchen, and community features like a travertine fireplace. With Highway 360 nearby, you'll appreciate convenient access to local shopping and dining. Explore the amenities and apartment options at The Clairborne by scheduling a tour today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an apartment complex courtyard with a large swimming pool, lounge chairs, umbrellas, and a gazebo.",
        "public_id": "019fc926-2ff8-7658-be86-0fcbc17a81ed",
        "storage_key": "property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Rayburn Elementary STEAM Academy 75050",
      "seo_description": "Explore The Clairborne in Grand Prairie, 75050, near Rayburn Elementary STEAM Academy. Enjoy modern living with convenient access and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "page_item_url": "apartments-near-the-university-of-texas-at-arlington",
      "search_query": "apartments near the university of texas at arlington",
      "category": "School",
      "h1_title": "Apartments Near The University of Texas at Arlington",
      "h2_subtitle": "Discover The Clairborne apartments near The University of Texas at Arlington, featuring modern amenities and convenient access to local destinations.",
      "page_copy": "Explore apartments near The University of Texas at Arlington at The Clairborne Apartment Homes in Grand Prairie, TX. The community offers convenient access to the university, nearby dining, entertainment, and other destinations in North Arlington.\n\nChoose from one-, two-, and three-bedroom floor plans featuring modern conveniences, including high-speed internet access and functional kitchens. Community amenities include a travertine fireplace and other shared spaces. Located near Highway 360, The Clairborne provides convenient access to the university and surrounding destinations.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an apartment complex courtyard with a large swimming pool, lounge chairs, umbrellas, and a gazebo.",
        "public_id": "019fc926-2ff8-7658-be86-0fcbc17a81ed",
        "storage_key": "property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near The University of Texas at Arlington",
      "seo_description": "Find convenient living at The Clairborne, near The University of Texas at Arlington. Enjoy modern amenities and easy university access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "page_item_url": "apartments-near-texas-health-arlington-memorial-hospital",
      "search_query": "apartments near Texas Health Arlington Memorial Hospital",
      "category": "Hospital",
      "h1_title": "Apartments Near Texas Health Arlington Memorial",
      "h2_subtitle": "Experience convenient living near Texas Health Arlington Memorial Hospital. The Clairborne offers easy access and exceptional amenities.",
      "page_copy": "The Clairborne Apartment Homes is a great choice for those searching for apartments near Texas Health Arlington Memorial Hospital. Located in Grand Prairie, our community provides a blend of convenience and comfort, with easy access to nearby healthcare facilities and local destinations.\n\nOur spacious one-, two-, and three-bedroom apartments feature amenities like high-speed internet, well-equipped kitchens, and elegant crown molding. The Clairborne's proximity to Highway 360 allows for convenient travel throughout North Arlington and access to Texas Health Arlington Memorial Hospital. Discover the convenience and amenities The Clairborne has to offer by scheduling a visit today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an apartment complex courtyard with a large swimming pool, lounge chairs, umbrellas, and a gazebo.",
        "public_id": "019fc926-2ff8-7658-be86-0fcbc17a81ed",
        "storage_key": "property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Texas Health Arlington Memorial",
      "seo_description": "Discover comfortable living at The Clairborne near Texas Health Arlington Memorial Hospital. Enjoy easy access and modern amenities in Grand Prairie.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "page_item_url": "apartments-near-fish-creek-linear-park-west-grand-prairie",
      "search_query": "apartments near Fish Creek Linear Park West Grand Prairie",
      "category": "Park",
      "h1_title": "Apartments Near Fish Creek Linear Park West",
      "h2_subtitle": "Embrace nature at Fish Creek Linear Park West. Discover The Clairborne's exceptional living options in Grand Prairie near this beautiful green space.",
      "page_copy": "Nestled near the lush landscapes of Fish Creek Linear Park West in Grand Prairie, The Clairborne Apartment Homes offer the perfect escape for nature lovers seeking proximity to outdoor adventures. Just minutes from the park, residents enjoy easy access to picturesque trails and serene picnic spots.\n\nOur community provides spacious living with beautifully crafted one, two, and three-bedroom homes equipped with modern amenities like high-speed internet and kitchen conveniences. The tranquil surroundings of Fish Creek Linear Park are complemented by our community’s inviting features such as a cozy travertine fireplace and elegant crown molding. Enjoy the harmonious blend of nature and modern living at The Clairborne, where comfort meets the great outdoors.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an apartment complex courtyard with a large swimming pool, lounge chairs, umbrellas, and a gazebo.",
        "public_id": "019fc926-2ff8-7658-be86-0fcbc17a81ed",
        "storage_key": "property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Fish Creek Linear Park West",
      "seo_description": "Explore The Clairborne near Fish Creek Linear Park West in Grand Prairie. Enjoy nature and modern amenities in our welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "page_item_url": "apartments-close-to-central-bark-dog-park-north-arlington",
      "search_query": "apartments close to Central Bark Dog Park North Arlington",
      "category": "Park",
      "h1_title": "Apartments Close to Central Bark Dog Park",
      "h2_subtitle": "Enjoy a pet-friendly lifestyle near Central Bark Dog Park in North Arlington. Discover The Clairborne's inviting community and spacious homes.",
      "page_copy": "Located in the heart of North Arlington, The Clairborne Apartment Homes are perfect for pet lovers seeking apartments close to Central Bark Dog Park. Our community offers not only convenient access to this popular pet-friendly park, but also a welcoming environment for both you and your furry companions.\n\nOur selection of one, two, and three-bedroom apartment homes are designed with spacious comfort and modern amenities such as high-speed internet access and kitchen facilities. Living at The Clairborne means quick access to Highway 360, making outings to Central Bark Dog Park effortless. Embrace the best in pet-friendly living and community amenities by choosing The Clairborne for your next home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an apartment complex courtyard with a large swimming pool, lounge chairs, umbrellas, and a gazebo.",
        "public_id": "019fc926-2ff8-7658-be86-0fcbc17a81ed",
        "storage_key": "property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Central Bark Dog Park",
      "seo_description": "Find pet-friendly living at The Clairborne near Central Bark Dog Park in North Arlington. Enjoy easy access and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "page_item_url": "the-clairborne-proximity-to-mi-familia-park-tx",
      "search_query": "The Clairborne proximity to Mi Familia Park TX",
      "category": "Park",
      "h1_title": "The Clairborne Near Mi Familia Park",
      "h2_subtitle": "Enjoy The Clairborne's convenient location near Mi Familia Park. Experience vibrant living in Grand Prairie, TX, with easy park access.",
      "page_copy": "At The Clairborne Apartment Homes, residents enjoy the perfect balance of urban living and outdoor recreation with Mi Familia Park just a short distance away. Our community is ideal for those seeking proximity to this scenic Grand Prairie park, providing an inviting escape into nature.\n\nFeaturing spacious one, two, and three-bedroom apartments, The Clairborne offers modern amenities like high-speed internet and well-appointed kitchens. The prime location near Highway 360 ensures seamless access to popular sites, including Mi Familia Park. Whether enjoying a picnic or a stroll, residents have plenty of opportunities to explore the great outdoors, all while experiencing the comfort and convenience of our beautifully maintained community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an apartment complex courtyard with a large swimming pool, lounge chairs, umbrellas, and a gazebo.",
        "public_id": "019fc926-2ff8-7658-be86-0fcbc17a81ed",
        "storage_key": "property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "The Clairborne Near Mi Familia Park",
      "seo_description": "Discover The Clairborne near Mi Familia Park in Grand Prairie, TX. Enjoy modern living with easy park access and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167591",
      "source": "custom",
      "page_item_url": "apartments-near-dallas-fort-worth-international-airport-75050",
      "search_query": "apartments near dallas fort worth international airport 75050",
      "category": "Transit",
      "h1_title": "Apartments Near DFW Airport 75050",
      "h2_subtitle": "Find convenient living at The Clairborne, just minutes from Dallas Fort Worth International Airport. Ideal for frequent travelers in the 75050 area.",
      "page_copy": "The Clairborne Apartment Homes offer unmatched convenience for those seeking apartments near Dallas Fort Worth International Airport, situated in the 75050 area. Perfect for frequent flyers and travel enthusiasts, our community ensures quick and easy access to DFW Airport while providing a serene residential experience.\n\nWith a selection of spacious one, two, and three-bedroom units, residents enjoy modern comforts like high-speed internet access and fully-equipped kitchens. Located near Highway 360, The Clairborne makes commuting a breeze, whether you're catching a flight or exploring nearby North Arlington. Experience the perfect blend of travel convenience and comfortable living at The Clairborne.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an apartment complex courtyard with a large swimming pool, lounge chairs, umbrellas, and a gazebo.",
        "public_id": "019fc926-2ff8-7658-be86-0fcbc17a81ed",
        "storage_key": "property/6767906449167591/019fc926-2ff8-7658-be86-0fcbc17a81ed.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near DFW Airport 75050",
      "seo_description": "Find comfort and convenience at The Clairborne, near DFW Airport in the 75050 area. Perfect for frequent travelers seeking modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12701876821"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-T62STJRJ"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Batch 4"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Preferred"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/f8e06e70-99d1-480e-95e5-4e2976b5b5b6/app.js?nocache=1&gaTracking=G-6YLDH26QB9&buttonbgcolor=1d428a&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "817-968-3169"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImpXYWlwQ1VFT0RHelQvWVRZZDZPZVE9PSIsInZhbHVlIjoiNEs0SXhEVXArR1FLeEJyejc4NUdJQT09IiwibWFjIjoiNGM5NzVmYjk5OGRjYjhlNGQ0OTZiYzhjZTNjOWQwYzViMjAwYmRmZmQ1ZTRiYTc2ODkxMTMzZjE5OTU0YjY1MSJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_repli_id": "12701876821",
  "custom_google_gtm_id": "GTM-T62STJRJ",
  "custom_rollout_phase": "Batch 4",
  "custom_vibesites_theme": "Preferred",
  "custom_ads_subscription": "essential",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/f8e06e70-99d1-480e-95e5-4e2976b5b5b6/app.js?nocache=1&gaTracking=G-6YLDH26QB9&buttonbgcolor=1d428a&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>",
  "custom_seo_subscription": "essential",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_ppc_tracking_phone_number": "817-968-3169",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImpXYWlwQ1VFT0RHelQvWVRZZDZPZVE9PSIsInZhbHVlIjoiNEs0SXhEVXArR1FLeEJyejc4NUdJQT09IiwibWFjIjoiNGM5NzVmYjk5OGRjYjhlNGQ0OTZiYzhjZTNjOWQwYzViMjAwYmRmZmQ1ZTRiYTc2ODkxMTMzZjE5OTU0YjY1MSJ9",
  "custom_audioeye_site_id": "a252cbed-cfe7-4655-9a90-8d750dc00540",
  "custom_audioeye_site_hash": "49f2045562de92df8c9fb13f8a133b5f"
};

export const generatedAt = '2026-11-03T23:01:44.794Z';
